(function() {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var COLOR_MODE_STORAGE_KEY = 'mrmaple_zone_map_color_mode';
  var VIEW_MODE_STORAGE_KEY = 'mrmaple_zone_map_view_mode';
  var MIN_ZOOM = 1;
  var MAX_ZOOM = 9;
  var ZOOM_STEP = 1.55;
  var SEARCH_RESULT_ZOOM = 7.1;
  var LOCATION_FOCUS_ZOOM = 7.6;
  var REGIONAL_LABEL_ZOOM = 2.25;
  var COUNTY_DETAIL_ZOOM = 4.45;
  var LOCATION_FOCUS_RING_RADIUS = 9;
  var ZIP_FOCUS_RING_RADIUS = 13;
  var SAVED_ZONE_FOCUS_RING_RADIUS = 36;
  var COUNTY_LAYER_ASSET_NAME = 'us-county-boundaries-conus.svg';
  var SEARCH_GEOCODE_URL = 'https://nominatim.openstreetmap.org/search';
  var HEAT_INDEX_ENABLED = false;
  var heatInstanceCounter = 0;
  var HEAT_ZONES = [
    { zone: 1, days: '<1' },
    { zone: 2, days: '1-7' },
    { zone: 3, days: '8-14' },
    { zone: 4, days: '15-30' },
    { zone: 5, days: '31-45' },
    { zone: 6, days: '46-60' },
    { zone: 7, days: '61-90' },
    { zone: 8, days: '91-120' },
    { zone: 9, days: '121-150' },
    { zone: 10, days: '151-180' },
    { zone: 11, days: '181-210' },
    { zone: 12, days: '210+' }
  ];
  var VIEW_MODES = [
    {
      id: 'hardiness',
      label: 'Zones',
      title: 'USDA growing zones',
      icon: 'zone'
    },
    {
      id: 'heat-index',
      label: 'Heat',
      title: 'Hot days above 86F',
      icon: 'heat'
    }
  ];
  var MAP_SURFACE_SELECTOR = '[data-zone-map-modal], [data-zone-map-standalone]';
  var DEFAULT_SOURCE_COPY = 'USDA zones use the official 2023 USDA/PRISM map.';
  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  var ALL_ZONES = [];
  for (var zoneNumber = 1; zoneNumber <= 13; zoneNumber += 1) {
    ALL_ZONES.push(zoneNumber + 'a');
    ALL_ZONES.push(zoneNumber + 'b');
  }

  function normalizeZoneLetter(letter) {
    return letter === 'a' || letter === 'b' ? letter : '';
  }

  function zoneIndexFromParts(number, letter, isUpperBound) {
    var n = parseInt(number, 10);
    if (isNaN(n) || n < 1 || n > 13) return null;
    var normalizedLetter = normalizeZoneLetter(letter);
    if (!normalizedLetter) {
      return (n * 2) - (isUpperBound ? 0 : 1);
    }
    return (n * 2) - (normalizedLetter === 'a' ? 1 : 0);
  }

  function zonePartsFromIndex(index) {
    var normalizedIndex = parseInt(index, 10);
    if (isNaN(normalizedIndex) || normalizedIndex < 1 || normalizedIndex > 26) return null;
    return {
      number: Math.ceil(normalizedIndex / 2),
      letter: normalizedIndex % 2 === 1 ? 'a' : 'b'
    };
  }

  function zoneLabel(number, letter) {
    return String(number) + normalizeZoneLetter(letter);
  }

  function buildZoneRange(startNumber, startLetter, endNumber, endLetter, hasExplicitEnd) {
    var a = parseInt(startNumber, 10);
    var b = parseInt(endNumber, 10);
    var startNormalizedLetter = normalizeZoneLetter(startLetter);
    var endNormalizedLetter = normalizeZoneLetter(endLetter);
    if (!hasExplicitEnd && startNormalizedLetter && !endNormalizedLetter) {
      endNormalizedLetter = startNormalizedLetter;
    }
    if (isNaN(a) || isNaN(b) || a < 1 || b < 1 || a > 13 || b > 13) return null;

    var minIndex = zoneIndexFromParts(a, startNormalizedLetter, false);
    var maxIndex = zoneIndexFromParts(b, endNormalizedLetter, true);
    if (minIndex === null || maxIndex === null) return null;

    if (minIndex > maxIndex) {
      var swapIndex = minIndex;
      minIndex = maxIndex;
      maxIndex = swapIndex;
    }

    var minParts = zonePartsFromIndex(minIndex);
    var maxParts = zonePartsFromIndex(maxIndex);
    if (!minParts || !maxParts) return null;

    var display = hasExplicitEnd
      ? (zoneLabel(minParts.number, startNormalizedLetter || minParts.letter) + '–' + zoneLabel(maxParts.number, endNormalizedLetter || maxParts.letter))
      : zoneLabel(a, startNormalizedLetter);

    if (!hasExplicitEnd && !startNormalizedLetter) {
      display = String(a);
    } else if (hasExplicitEnd && !startNormalizedLetter && !endNormalizedLetter) {
      display = a === b ? String(a) : (a + '–' + b);
    } else if (minIndex === maxIndex) {
      display = zoneLabel(minParts.number, minParts.letter);
    }

    return {
      min: minParts.number,
      max: maxParts.number,
      minIndex: minIndex,
      maxIndex: maxIndex,
      minLabel: zoneLabel(minParts.number, minParts.letter),
      maxLabel: zoneLabel(maxParts.number, maxParts.letter),
      display: display
    };
  }

  function parseStrictZoneInputFallback(raw) {
    if (!raw) return null;
    var source = String(raw).trim().toLowerCase();
    source = source
      .replace(/^usda\s*/i, '')
      .replace(/^zones?\s*/i, '')
      .replace(/\bthrough\b|\bthru\b|\bto\b/g, '-')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, '');
    var match = source.match(/^(\d{1,2})([ab])?(?:-(\d{1,2})([ab])?)?$/);
    if (!match) return null;
    return buildZoneRange(match[1], match[2], match[3] || match[1], match[4], Boolean(match[3]));
  }

  function parseZoneRangeFromTextFallback(raw) {
    if (!raw) return null;
    var source = String(raw).toLowerCase();
    source = source.replace(/[–—]/g, '-').replace(/\bthrough\b|\bthru\b|\bto\b/g, '-');

    var segments = [];
    var segmentMatch;
    var segmentRegex = /(?:usda\s*)?zones?[^.;\n\r]{0,120}/g;
    while ((segmentMatch = segmentRegex.exec(source)) !== null) {
      segments.push(segmentMatch[0]);
    }
    if (!segments.length) segments.push(source);

    var min = null;
    var max = null;

    function include(zoneNumber) {
      var n = parseInt(zoneNumber, 10);
      if (isNaN(n) || n < 1 || n > 13) return;
      if (min === null || n < min) min = n;
      if (max === null || n > max) max = n;
    }

    for (var i = 0; i < segments.length; i += 1) {
      var chunk = segments[i];
      var rangeRegex = /([1-9]|1[0-3])\s*([ab])?\s*-\s*([1-9]|1[0-3])\s*([ab])?/g;
      var rangeMatch;
      while ((rangeMatch = rangeRegex.exec(chunk)) !== null) {
        var detailedRange = buildZoneRange(rangeMatch[1], rangeMatch[2], rangeMatch[3], rangeMatch[4], true);
        if (detailedRange) return detailedRange;
      }

      var zoneRegex = /\b([1-9]|1[0-3])\s*([ab])?\b/g;
      var zoneMatch;
      while ((zoneMatch = zoneRegex.exec(chunk)) !== null) {
        include(zoneMatch[1]);
      }
    }

    if (min === null || max === null) return null;
    return buildZoneRange(min, '', max, '', min !== max);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function getUtils() {
    return window.MrMapleZoneUtils || {};
  }

  function parseRange(raw) {
    var utils = getUtils();
    if (!raw) return null;
    if (typeof utils.parseStrictZoneInput === 'function') {
      return utils.parseStrictZoneInput(raw) || null;
    }
    return parseStrictZoneInputFallback(raw) || null;
  }

  function parseRangeFromText(raw) {
    var utils = getUtils();
    if (!raw) return null;
    if (typeof utils.parseZoneRangeFromText === 'function') {
      return utils.parseZoneRangeFromText(raw) || null;
    }
    return parseZoneRangeFromTextFallback(raw) || null;
  }

  function formatRange(range) {
    var utils = getUtils();
    if (!range) return '';
    if (typeof utils.formatZoneRange === 'function') {
      return utils.formatZoneRange(range);
    }
    return range.display || '';
  }

  function getSavedZone() {
    var utils = getUtils();
    if (typeof utils.getSavedZone === 'function') {
      try {
        return utils.getSavedZone();
      } catch (error) {
        return null;
      }
    }
    try {
      return localStorage.getItem('usdaZone') || localStorage.getItem('mrmaple_zone');
    } catch (error) {
      return null;
    }
  }

  function readStringAttribute(element, name) {
    if (!element) return '';
    return String(element.getAttribute(name) || '').trim();
  }

  function normalizeText(raw) {
    return String(raw || '')
      .replace(/\s+/g, ' ')
      .replace(/\s*,\s*/g, ', ')
      .trim();
  }

  function normalizeLocationSearchText(raw) {
    return normalizeText(raw).replace(/\b([A-Z]{2})(\d{5}(?:-\d{4})?)\b/gi, function(_match, state, zip) {
      return String(state || '').toUpperCase() + ' ' + zip;
    });
  }

  function extractZipCode(raw) {
    var match = normalizeText(raw).match(/\b(\d{5})(?:-\d{4})?\b/);
    return match ? match[1] : '';
  }

  function isVisibleElement(element) {
    if (!(element instanceof Element)) return false;
    if (element.hidden) return false;
    var style = window.getComputedStyle(element);
    if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
    if (style.opacity === '0') return false;
    return true;
  }

  function cleanDetectedShippingText(raw) {
    var text = normalizeText(raw);
    if (!text) return '';
    text = text
      .replace(/^.*?\bdeliver to\b[:\s-]*/i, '')
      .replace(/\bpayment\b.*$/i, '')
      .replace(/\bselected size\b.*$/i, '')
      .replace(/\badd to cart\b.*$/i, '')
      .replace(/\bbuy now\b.*$/i, '')
      .replace(/\bshare this\b.*$/i, '')
      .trim();
    return normalizeText(text);
  }

  function detectShippingAddressFromDom() {
    var preferredSelectors = [
      '[data-shipping-address]',
      '[data-delivery-address]',
      '[data-deliver-to]',
      '.shipping-address',
      '.delivery-address',
      '.deliver-to',
      'address'
    ];

    for (var i = 0; i < preferredSelectors.length; i += 1) {
      var candidates = document.querySelectorAll(preferredSelectors[i]);
      for (var j = 0; j < candidates.length; j += 1) {
        var candidate = candidates[j];
        if (!isVisibleElement(candidate)) continue;
        var candidateText = cleanDetectedShippingText(candidate.textContent || '');
        if (candidateText && (extractZipCode(candidateText) || /,\s*[A-Z]{2}\b/.test(candidateText))) {
          return candidateText;
        }
      }
    }

    var textCandidates = document.querySelectorAll('p, span, div, button');
    for (var k = 0; k < textCandidates.length; k += 1) {
      var textCandidate = textCandidates[k];
      if (!isVisibleElement(textCandidate)) continue;
      var rawText = normalizeText(textCandidate.textContent || '');
      if (!/\bdeliver to\b/i.test(rawText)) continue;
      var detectedText = cleanDetectedShippingText(rawText);
      if (detectedText) return detectedText;
    }

    return '';
  }

  function getShippingAddressText(modal) {
    var state = getState(modal);
    if (state.shippingAddressText) return state.shippingAddressText;

    var inlineAddress = readStringAttribute(modal, 'data-zone-map-shipping-address');
    var detectedAddress = detectShippingAddressFromDom();
    state.shippingAddressText = normalizeLocationSearchText(inlineAddress || detectedAddress || '');
    return state.shippingAddressText;
  }

  function getShippingZipCode(modal) {
    var inlineZip = readStringAttribute(modal, 'data-zone-map-shipping-zip');
    return extractZipCode(inlineZip) || extractZipCode(getShippingAddressText(modal));
  }

  function readJsonAttribute(element, name) {
    if (!element) return null;
    var raw = element.getAttribute(name);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function rangeContainsIndex(range, index) {
    if (!range) return false;
    return index >= range.minIndex && index <= range.maxIndex;
  }

  function zoneToIndex(zoneLabel) {
    if (!zoneLabel) return -1;
    return ALL_ZONES.indexOf(String(zoneLabel).toLowerCase()) + 1;
  }

  function normalizeColorMode(raw) {
    return raw === 'colorblind' ? 'colorblind' : 'default';
  }

  function normalizeViewMode(raw) {
    if (!HEAT_INDEX_ENABLED) return 'hardiness';
    return raw === 'heat-index' ? raw : 'hardiness';
  }

  function getStoredColorMode() {
    try {
      return normalizeColorMode(localStorage.getItem(COLOR_MODE_STORAGE_KEY));
    } catch (error) {
      return 'default';
    }
  }

  function getStoredViewMode() {
    try {
      return normalizeViewMode(localStorage.getItem(VIEW_MODE_STORAGE_KEY));
    } catch (error) {
      return 'hardiness';
    }
  }

  function storeColorMode(mode) {
    try {
      localStorage.setItem(COLOR_MODE_STORAGE_KEY, normalizeColorMode(mode));
    } catch (error) {
      // Ignore storage failures and fall back to the current page state.
    }
  }

  function storeViewMode(mode) {
    try {
      localStorage.setItem(VIEW_MODE_STORAGE_KEY, normalizeViewMode(mode));
    } catch (error) {
      // Ignore storage failures and fall back to the current page state.
    }
  }

  function getViewModeConfig(mode) {
    var normalizedMode = normalizeViewMode(mode);
    for (var i = 0; i < VIEW_MODES.length; i += 1) {
      if (VIEW_MODES[i].id === normalizedMode) return VIEW_MODES[i];
    }
    return VIEW_MODES[0];
  }

  function isHeatOverlayMode(mode) {
    if (!HEAT_INDEX_ENABLED) return false;
    var normalizedMode = normalizeViewMode(mode);
    return normalizedMode === 'heat-index';
  }

  function isStandaloneMap(modal) {
    return Boolean(modal && modal.getAttribute('data-zone-map-standalone') === 'true');
  }

  function prefersReducedMotion() {
    if (!window.matchMedia) return false;
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (error) {
      return false;
    }
  }

  function getMapSurfaces() {
    return Array.prototype.slice.call(document.querySelectorAll(MAP_SURFACE_SELECTOR));
  }

  // Deep blue (coolest, AHS heat zone 1) to bright red (hottest, zone 12).
  // The baked SVG carries matching default --heat-color values; this is used to
  // recolor for colorblind mode and to build the legend gradient.
  function getHeatZoneColor(heatZoneNumber, colorMode) {
    var index = Math.max(1, Math.min(12, parseInt(heatZoneNumber, 10) || 1));
    var progress = (index - 1) / 11;

    if (normalizeColorMode(colorMode) === 'colorblind') {
      var cbHue = 264 - (progress * 226); // violet -> amber
      var cbSat = 52 + (progress * 30);
      var cbLight = 46 + (progress * 8);
      return 'hsl(' + cbHue.toFixed(1) + ' ' + cbSat.toFixed(1) + '% ' + cbLight.toFixed(1) + '%)';
    }

    var hue = 222 - (progress * 222); // deep blue -> red
    var sat = 70 + (progress * 25);
    var light = 38 + (progress * 14);
    return 'hsl(' + hue.toFixed(1) + ' ' + sat.toFixed(1) + '% ' + light.toFixed(1) + '%)';
  }

  function formatHeatZoneLabel(heatZone) {
    if (!heatZone) return '';
    return 'AHS heat zone ' + heatZone.zone + ' (' + heatZone.days + ' days >86F)';
  }

  function getZoneColor(index, colorMode, viewMode) {
    var progress = Math.max(0, Math.min(1, (index - 1) / (ALL_ZONES.length - 1)));
    var normalizedView = normalizeViewMode(viewMode);
    var isColorblind = normalizeColorMode(colorMode) === 'colorblind';

    if (normalizedView === 'heat-index') {
      // Heat-index palette: cool blues for low USDA zones to deep reds for the hottest.
      // Colorblind variant keeps the cool→warm axis but swaps in purple→amber for
      // protanopia/deuteranopia distinguishability.
      if (isColorblind) {
        var cbHue = 268 - (progress * 230); // 268 (violet) -> 38 (amber)
        var cbSat = 38 + (progress * 26);
        var cbLight = 88 - (progress * 32);
        return 'hsl(' + cbHue.toFixed(1) + ' ' + cbSat.toFixed(1) + '% ' + cbLight.toFixed(1) + '%)';
      }
      var heatHue = 214 - (progress * 214); // 214 (cool blue) -> 0 (deep red)
      var heatSat = 52 + (progress * 22);
      var heatLight = 84 - (progress * 36);
      return 'hsl(' + heatHue.toFixed(1) + ' ' + heatSat.toFixed(1) + '% ' + heatLight.toFixed(1) + '%)';
    }

    if (isColorblind) {
      var hue = 218 - (progress * 42);
      var saturation = 34 + (progress * 10);
      var lightness = 92 - (progress * 28);
      return 'hsl(' + hue.toFixed(1) + ' ' + saturation.toFixed(1) + '% ' + lightness.toFixed(1) + '%)';
    }

    var defHue = 92 - (progress * 48);
    var defSat = 26 + (progress * 8);
    var defLight = 87 - (progress * 20);
    return 'hsl(' + defHue.toFixed(1) + ' ' + defSat.toFixed(1) + '% ' + defLight.toFixed(1) + '%)';
  }

  function getColorMode(modal) {
    var state = getState(modal);
    if (!state.colorMode) {
      state.colorMode = getStoredColorMode();
    }
    return state.colorMode;
  }

  function getViewMode(modal) {
    var state = getState(modal);
    if (!state.viewMode) {
      state.viewMode = getStoredViewMode();
    }
    return state.viewMode;
  }

  function clampNumber(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function shouldAnimateMapView() {
    if (!window.matchMedia) return true;
    try {
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (error) {
      return true;
    }
  }

  function easeOutCubic(progress) {
    var t = clampNumber(progress, 0, 1);
    return 1 - Math.pow(1 - t, 3);
  }

  function cancelMapViewAnimation(state) {
    if (state && state.mapAnimationFrame) {
      window.cancelAnimationFrame(state.mapAnimationFrame);
      state.mapAnimationFrame = null;
    }
  }

  function cloneViewBox(box) {
    if (!box) return null;
    return {
      x: box.x,
      y: box.y,
      width: box.width,
      height: box.height
    };
  }

  function parseSvgViewBox(svg) {
    if (!svg) return null;

    var raw = svg.getAttribute('viewBox') || '';
    var parts = raw.trim().split(/[\s,]+/).map(function(part) {
      return parseFloat(part);
    });

    if (parts.length === 4 && parts.every(function(part) { return isFinite(part); }) && parts[2] > 0 && parts[3] > 0) {
      return {
        x: parts[0],
        y: parts[1],
        width: parts[2],
        height: parts[3]
      };
    }

    if (svg.viewBox && svg.viewBox.baseVal && svg.viewBox.baseVal.width > 0 && svg.viewBox.baseVal.height > 0) {
      return {
        x: svg.viewBox.baseVal.x,
        y: svg.viewBox.baseVal.y,
        width: svg.viewBox.baseVal.width,
        height: svg.viewBox.baseVal.height
      };
    }

    return null;
  }

  function formatViewBoxNumber(value) {
    return String(Math.round(value * 1000) / 1000);
  }

  function setSvgViewBox(svg, box) {
    if (!svg || !box) return;
    var value = [
      formatViewBoxNumber(box.x),
      formatViewBoxNumber(box.y),
      formatViewBoxNumber(box.width),
      formatViewBoxNumber(box.height)
    ].join(' ');
    if (svg.__zoneMapLastViewBox === value) return;
    svg.__zoneMapLastViewBox = value;
    svg.setAttribute('viewBox', value);
  }

  function clampViewBoxToBase(box, baseBox) {
    if (!box || !baseBox) return null;

    var width = clampNumber(box.width, baseBox.width / MAX_ZOOM, baseBox.width);
    var height = clampNumber(box.height, baseBox.height / MAX_ZOOM, baseBox.height);
    var maxX = baseBox.x + baseBox.width - width;
    var maxY = baseBox.y + baseBox.height - height;

    return {
      x: clampNumber(box.x, baseBox.x, maxX),
      y: clampNumber(box.y, baseBox.y, maxY),
      width: width,
      height: height
    };
  }

  function getCurrentViewBox(modal) {
    var state = getState(modal);
    return parseSvgViewBox(state.svg) || cloneViewBox(state.viewBox) || cloneViewBox(state.baseViewBox);
  }

  function animateMapViewBox(modal, targetBox, targetZoom, options) {
    var state = getState(modal);
    if (!state.svg || !state.baseViewBox || !targetBox) return;

    var clampedBox = clampViewBoxToBase(targetBox, state.baseViewBox);
    if (!clampedBox) return;

    var currentBox = getCurrentViewBox(modal) || cloneViewBox(clampedBox);
    var startZoom = state.zoom || MIN_ZOOM;
    var nextZoom = clampNumber(targetZoom || (state.baseViewBox.width / clampedBox.width), MIN_ZOOM, MAX_ZOOM);
    var duration = options && typeof options.duration === 'number' ? options.duration : 420;

    cancelMapViewAnimation(state);

    if (!shouldAnimateMapView() || duration <= 0 || !currentBox) {
      state.viewBox = clampedBox;
      state.zoom = nextZoom;
      setSvgViewBox(state.svg, clampedBox);
      updateZoomControls(modal);
      return;
    }

    var startTime = null;

    function tick(timestamp) {
      if (startTime === null) startTime = timestamp;
      var progress = clampNumber((timestamp - startTime) / duration, 0, 1);
      var eased = easeOutCubic(progress);
      var frameBox = {
        x: currentBox.x + ((clampedBox.x - currentBox.x) * eased),
        y: currentBox.y + ((clampedBox.y - currentBox.y) * eased),
        width: currentBox.width + ((clampedBox.width - currentBox.width) * eased),
        height: currentBox.height + ((clampedBox.height - currentBox.height) * eased)
      };

      state.viewBox = frameBox;
      state.zoom = startZoom + ((nextZoom - startZoom) * eased);
      setSvgViewBox(state.svg, frameBox);
      syncZoomDataset(modal, state.zoom);

      if (progress < 1) {
        state.mapAnimationFrame = window.requestAnimationFrame(tick);
      } else {
        state.mapAnimationFrame = null;
        state.viewBox = clampedBox;
        state.zoom = nextZoom;
        setSvgViewBox(state.svg, clampedBox);
        updateZoomControls(modal);
      }
    }

    state.mapAnimationFrame = window.requestAnimationFrame(tick);
  }

  function updateZoomControls(modal) {
    var state = getState(modal);
    var isReady = Boolean(state.svg && state.baseViewBox);
    var zoom = isReady ? state.zoom : MIN_ZOOM;

    var isZoomed = syncZoomDataset(modal, zoom);

    if (state.zoomInButton) {
      state.zoomInButton.disabled = !isReady || zoom >= MAX_ZOOM - 0.01;
    }
    if (state.zoomOutButton) {
      state.zoomOutButton.disabled = !isReady || zoom <= MIN_ZOOM + 0.01;
    }
    if (state.zoomResetButton) {
      state.zoomResetButton.disabled = !isReady || !isZoomed;
    }
    if (state.zoomStatus) {
      state.zoomStatus.textContent = Math.round(zoom * 100) + '% zoom';
    }

    syncMapDetailLevel(modal);
    updateUserMarker(modal, getUserRange(modal));
  }

  function syncZoomDataset(modal, zoom) {
    if (!modal) return false;
    var normalizedZoom = isFinite(zoom) ? zoom : MIN_ZOOM;
    var isZoomed = normalizedZoom > MIN_ZOOM + 0.01;
    var zoomedValue = isZoomed ? 'true' : 'false';
    var levelValue = normalizedZoom.toFixed(2);

    if (modal.getAttribute('data-zone-map-zoomed') !== zoomedValue) {
      modal.setAttribute('data-zone-map-zoomed', zoomedValue);
    }
    if (modal.getAttribute('data-zone-map-zoom-level') !== levelValue) {
      modal.setAttribute('data-zone-map-zoom-level', levelValue);
    }

    return isZoomed;
  }

  function applyMapViewBox(modal, box, zoom, options) {
    var state = getState(modal);
    if (!state.svg || !state.baseViewBox || !box) return;

    var clampedBox = clampViewBoxToBase(box, state.baseViewBox);
    if (!clampedBox) return;

    var targetZoom = clampNumber(zoom || (state.baseViewBox.width / clampedBox.width), MIN_ZOOM, MAX_ZOOM);

    if (options && options.animate) {
      animateMapViewBox(modal, clampedBox, targetZoom, options);
      return;
    }

    cancelMapViewAnimation(state);
    state.viewBox = clampedBox;
    state.zoom = targetZoom;
    setSvgViewBox(state.svg, clampedBox);
    if (!options || options.updateControls !== false) {
      updateZoomControls(modal);
    }
  }

  function resetMapView(modal, options) {
    var state = getState(modal);
    if (!state.svg || !state.baseViewBox) return;
    applyMapViewBox(modal, cloneViewBox(state.baseViewBox), MIN_ZOOM, options);
  }

  function setMapZoom(modal, nextZoom, anchorPoint, options) {
    var state = getState(modal);
    if (!state.svg || !state.baseViewBox) return;

    var currentBox = getCurrentViewBox(modal);
    if (!currentBox) return;

    var zoom = clampNumber(nextZoom, MIN_ZOOM, MAX_ZOOM);
    var nextWidth = state.baseViewBox.width / zoom;
    var nextHeight = state.baseViewBox.height / zoom;
    var anchor = anchorPoint || {
      x: currentBox.x + (currentBox.width / 2),
      y: currentBox.y + (currentBox.height / 2)
    };
    var ratioX = currentBox.width > 0 ? ((anchor.x - currentBox.x) / currentBox.width) : 0.5;
    var ratioY = currentBox.height > 0 ? ((anchor.y - currentBox.y) / currentBox.height) : 0.5;

    applyMapViewBox(
      modal,
      {
        x: anchor.x - (ratioX * nextWidth),
        y: anchor.y - (ratioY * nextHeight),
        width: nextWidth,
        height: nextHeight
      },
      zoom,
      options
    );
  }

  function focusMapOnPoint(modal, point, zoom, options) {
    var state = getState(modal);
    if (!state.svg || !state.baseViewBox || !point) return;

    var targetZoom = clampNumber(zoom || SEARCH_RESULT_ZOOM, MIN_ZOOM, MAX_ZOOM);
    var width = state.baseViewBox.width / targetZoom;
    var height = state.baseViewBox.height / targetZoom;

    applyMapViewBox(
      modal,
      {
        x: point.x - (width / 2),
        y: point.y - (height / 2),
        width: width,
        height: height
      },
      targetZoom,
      options
    );
  }

  function getSvgPointFromClient(modal, clientX, clientY) {
    var state = getState(modal);
    if (!state.svg) return null;

    var box = getCurrentViewBox(modal);
    var rect = state.svg.getBoundingClientRect();
    if (!box || !rect.width || !rect.height) return null;

    var ratioX = clampNumber((clientX - rect.left) / rect.width, 0, 1);
    var ratioY = clampNumber((clientY - rect.top) / rect.height, 0, 1);

    return {
      x: box.x + (ratioX * box.width),
      y: box.y + (ratioY * box.height)
    };
  }

  function createInlineIcon(name) {
    var icon = document.createElementNS(SVG_NS, 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.setAttribute('class', 'product-zone-map-modal__icon');

    function append(tagName, attrs) {
      var node = document.createElementNS(SVG_NS, tagName);
      Object.keys(attrs).forEach(function(key) {
        node.setAttribute(key, attrs[key]);
      });
      icon.appendChild(node);
    }

    if (name === 'heat') {
      // Sun = heat.
      append('circle', { cx: '12', cy: '12', r: '4' });
      append('path', { d: 'M12 2v2.4' });
      append('path', { d: 'M12 19.6V22' });
      append('path', { d: 'M2 12h2.4' });
      append('path', { d: 'M19.6 12H22' });
      append('path', { d: 'm4.93 4.93 1.7 1.7' });
      append('path', { d: 'm17.37 17.37 1.7 1.7' });
      append('path', { d: 'm19.07 4.93-1.7 1.7' });
      append('path', { d: 'm6.63 17.37-1.7 1.7' });
    } else if (name === 'layers') {
      // Combined = sun rays (right) + snowflake arms (left) sharing one core.
      append('circle', { cx: '12', cy: '12', r: '3.3' });
      append('path', { d: 'M15.3 12H21' });
      append('path', { d: 'm16.6 7.6 2.9-2.9' });
      append('path', { d: 'm16.6 16.4 2.9 2.9' });
      append('path', { d: 'M8.7 12H3' });
      append('path', { d: 'm7.4 7.6-2.9-2.9' });
      append('path', { d: 'm7.4 16.4-2.9 2.9' });
      append('path', { d: 'm4.1 8 0.4 2-2 0.4' });
      append('path', { d: 'm4.1 16 0.4-2-2-0.4' });
    } else if (name === 'zone') {
      // Snowflake = cold hardiness.
      append('path', { d: 'M12 2v20' });
      append('path', { d: 'M2 12h20' });
      append('path', { d: 'm4.93 4.93 14.14 14.14' });
      append('path', { d: 'm19.07 4.93-14.14 14.14' });
      append('path', { d: 'm16 4-4 4-4-4' });
      append('path', { d: 'm8 20 4-4 4 4' });
      append('path', { d: 'm4 8 4 4-4 4' });
      append('path', { d: 'm20 16-4-4 4-4' });
    } else if (name === 'location') {
      append('path', { d: 'M12 2v4' });
      append('path', { d: 'M12 18v4' });
      append('path', { d: 'M2 12h4' });
      append('path', { d: 'M18 12h4' });
      append('circle', { cx: '12', cy: '12', r: '4' });
    } else if (name === 'play') {
      append('path', { d: 'M8 5v14l11-7-11-7Z' });
    } else if (name === 'pause') {
      append('path', { d: 'M8 5v14' });
      append('path', { d: 'M16 5v14' });
    } else {
      append('circle', { cx: '12', cy: '12', r: '8' });
      append('path', { d: 'M12 4v16' });
      append('path', { d: 'M4 12h16' });
    }

    return icon;
  }

  function ensureMapControlTray(modal) {
    var stage = modal && modal.querySelector('.product-zone-map-modal__stage');
    if (!stage) return null;

    var tray = stage.querySelector('[data-zone-map-control-tray]');
    if (!tray) {
      tray = document.createElement('div');
      tray.className = 'product-zone-map-modal__control-tray';
      tray.setAttribute('data-zone-map-control-tray', '');
      stage.appendChild(tray);
    }
    return tray;
  }

  function createZoomButton(action, label, ariaLabel) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-zone-map-modal__zoom-button';
    button.setAttribute('data-zone-map-zoom', action);
    button.setAttribute('aria-label', ariaLabel);
    button.textContent = label;
    return button;
  }

  function ensureZoomControls(modal) {
    var state = getState(modal);
    var tray = ensureMapControlTray(modal);
    if (!tray) return;

    var controls = tray.querySelector('[data-zone-map-zoom-controls]');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'product-zone-map-modal__zoom-controls';
      controls.setAttribute('data-zone-map-zoom-controls', '');
      controls.setAttribute('role', 'group');
      controls.setAttribute('aria-label', 'Map zoom controls');

      controls.appendChild(createZoomButton('in', '+', 'Zoom in'));
      controls.appendChild(createZoomButton('out', '-', 'Zoom out'));
      controls.appendChild(createZoomButton('reset', '1x', 'Reset map zoom'));
      tray.appendChild(controls);
    }

    state.zoomControls = controls;
    state.zoomInButton = controls.querySelector('[data-zone-map-zoom="in"]');
    state.zoomOutButton = controls.querySelector('[data-zone-map-zoom="out"]');
    state.zoomResetButton = controls.querySelector('[data-zone-map-zoom="reset"]');

    if (!state.zoomStatus) {
      var status = document.createElement('span');
      status.className = 'product-zone-map-modal__zoom-status';
      status.setAttribute('data-zone-map-zoom-status', '');
      status.setAttribute('aria-live', 'polite');
      tray.appendChild(status);
      state.zoomStatus = status;
    }

    updateZoomControls(modal);
  }

  function ensureLocationControl(modal) {
    var state = getState(modal);
    var tray = ensureMapControlTray(modal);
    if (!tray) return;

    var button = tray.querySelector('[data-zone-map-location-focus]');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-zone-map-modal__location-button';
      button.setAttribute('data-zone-map-location-focus', '');
      button.setAttribute('aria-label', 'Focus map on my location');
      button.appendChild(createInlineIcon('location'));
      tray.appendChild(button);
    }

    state.locationButton = button;
  }

  function ensureActionBar(modal) {
    var sheet = modal && modal.querySelector('.product-zone-map-modal__sheet');
    if (!sheet) return null;

    var stage = modal.querySelector('.product-zone-map-modal__stage');
    var actions = modal.querySelector('.product-zone-map-modal__actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'product-zone-map-modal__actions';
    }

    if (stage && stage.parentNode === sheet && actions.nextElementSibling !== stage) {
      sheet.insertBefore(actions, stage);
    } else if (!actions.parentNode) {
      sheet.appendChild(actions);
    }

    return actions;
  }

  function createSourceDetails() {
    var source = document.createElement('details');
    source.className = 'product-zone-map-modal__source';

    var summary = document.createElement('summary');
    summary.className = 'product-zone-map-modal__source-trigger';
    summary.textContent = '?';
    summary.setAttribute('aria-label', 'Map data source details');

    var copy = document.createElement('p');
    copy.className = 'product-zone-map-modal__source-text';
    copy.textContent = DEFAULT_SOURCE_COPY;

    source.appendChild(summary);
    source.appendChild(copy);
    return source;
  }

  function ensureSourcePlacement(modal) {
    var tray = ensureMapControlTray(modal);
    if (!tray) return;

    var source = modal && modal.querySelector('.product-zone-map-modal__source');
    if (!source) {
      source = createSourceDetails();
    }

    var copy = source.querySelector('.product-zone-map-modal__source-text');
    if (copy && !copy.textContent.trim()) {
      copy.textContent = DEFAULT_SOURCE_COPY;
    }

    if (source.parentNode !== tray) {
      tray.appendChild(source);
    }
  }

  function initializeMapView(modal) {
    var state = getState(modal);
    if (!state.svg) return;

    state.baseViewBox = parseSvgViewBox(state.svg);
    state.viewBox = cloneViewBox(state.baseViewBox);
    state.zoom = MIN_ZOOM;

    if (state.baseViewBox) {
      state.svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      setSvgViewBox(state.svg, state.baseViewBox);
    }

    updateZoomControls(modal);
  }

  function handleZoomControl(modal, control) {
    if (!control) return;
    var state = getState(modal);
    var action = control.getAttribute('data-zone-map-zoom');

    if (action === 'in') {
      setMapZoom(modal, state.zoom * ZOOM_STEP, null, { animate: true, duration: 360 });
    } else if (action === 'out') {
      setMapZoom(modal, state.zoom / ZOOM_STEP, null, { animate: true, duration: 360 });
    } else if (action === 'reset') {
      resetMapView(modal, { animate: true, duration: 420 });
    }
  }

  function applyPendingMapPan(modal) {
    var state = getState(modal);
    if (!state.isPanning || !state.panStartViewBox || !state.panStartRect) return;
    if (!state.panStartRect.width || !state.panStartRect.height) return;

    var dx = ((state.panLatestClientX - state.panStartClientX) / state.panStartRect.width) * state.panStartViewBox.width;
    var dy = ((state.panLatestClientY - state.panStartClientY) / state.panStartRect.height) * state.panStartViewBox.height;
    applyMapViewBox(
      modal,
      {
        x: state.panStartViewBox.x - dx,
        y: state.panStartViewBox.y - dy,
        width: state.panStartViewBox.width,
        height: state.panStartViewBox.height
      },
      state.zoom,
      { updateControls: false }
    );
  }

  function schedulePendingMapPan(modal) {
    var state = getState(modal);
    if (state.panAnimationFrame) return;
    state.panAnimationFrame = window.requestAnimationFrame(function() {
      state.panAnimationFrame = null;
      applyPendingMapPan(modal);
    });
  }

  function endMapPan(modal, stage, pointerId) {
    var state = getState(modal);
    if (!state.isPanning) return;
    if (pointerId !== undefined && state.panPointerId !== pointerId) return;

    if (state.panAnimationFrame) {
      window.cancelAnimationFrame(state.panAnimationFrame);
      state.panAnimationFrame = null;
      applyPendingMapPan(modal);
    }

    if (stage && typeof stage.releasePointerCapture === 'function' && state.panPointerId !== null) {
      try {
        stage.releasePointerCapture(state.panPointerId);
      } catch (error) {
        // Ignore release errors when the browser has already cleared capture.
      }
    }

    state.isPanning = false;
    state.panPointerId = null;
    state.panStartRect = null;
    state.panStartViewBox = null;
    modal.setAttribute('data-zone-map-panning', 'false');
    updateZoomControls(modal);
  }

  function getPointerDistance(a, b) {
    if (!a || !b) return 0;
    var dx = a.clientX - b.clientX;
    var dy = a.clientY - b.clientY;
    return Math.sqrt((dx * dx) + (dy * dy));
  }

  function getPointerCenter(a, b) {
    if (!a || !b) return null;
    return {
      clientX: (a.clientX + b.clientX) / 2,
      clientY: (a.clientY + b.clientY) / 2
    };
  }

  function getActivePointerList(state) {
    return Object.keys(state.activePointers || {}).map(function(id) {
      return state.activePointers[id];
    });
  }

  function resetPinchState(modal) {
    var state = getState(modal);
    state.isPinching = false;
    state.pinchStartDistance = 0;
    state.pinchStartZoom = MIN_ZOOM;
    state.pinchStartAnchor = null;
    modal.setAttribute('data-zone-map-pinching', 'false');
  }

  function bindMapZoomInteractions(modal) {
    var stage = modal && modal.querySelector('.product-zone-map-modal__stage');
    if (!stage || stage.getAttribute('data-zone-map-zoom-bound') === 'true') return;
    stage.setAttribute('data-zone-map-zoom-bound', 'true');

    stage.addEventListener('wheel', function(event) {
      var state = getState(modal);
      if (!state.svg || !state.baseViewBox || !event.deltaY) return;

      event.preventDefault();
      var anchor = getSvgPointFromClient(modal, event.clientX, event.clientY);
      var nextZoom = event.deltaY < 0
        ? state.zoom * ZOOM_STEP
        : state.zoom / ZOOM_STEP;
      setMapZoom(modal, nextZoom, anchor, { animate: false });
    }, { passive: false });

    stage.addEventListener('pointerdown', function(event) {
      var target = event.target;
      var state = getState(modal);
      if (!(target instanceof Element)) return;
      if (target.closest('[data-zone-map-control-tray]')) return;
      if (!state.svg || !state.baseViewBox) return;
      if (event.button !== undefined && event.button !== 0) return;

      state.activePointers[String(event.pointerId)] = {
        clientX: event.clientX,
        clientY: event.clientY
      };

      var pointers = getActivePointerList(state);
      if (pointers.length >= 2) {
        endMapPan(modal, stage);
        var first = pointers[0];
        var second = pointers[1];
        var center = getPointerCenter(first, second);
        state.isPinching = true;
        state.pinchStartDistance = getPointerDistance(first, second);
        state.pinchStartZoom = state.zoom || MIN_ZOOM;
        state.pinchStartAnchor = center ? getSvgPointFromClient(modal, center.clientX, center.clientY) : null;
        modal.setAttribute('data-zone-map-pinching', 'true');
        if (typeof stage.setPointerCapture === 'function') {
          try { stage.setPointerCapture(event.pointerId); } catch (error) {}
        }
        event.preventDefault();
        return;
      }

      if (state.zoom <= MIN_ZOOM + 0.01) {
        return;
      }

      state.isPanning = true;
      state.panPointerId = event.pointerId;
      state.panStartClientX = event.clientX;
      state.panStartClientY = event.clientY;
      state.panLatestClientX = event.clientX;
      state.panLatestClientY = event.clientY;
      state.panStartViewBox = getCurrentViewBox(modal);
      state.panStartRect = state.svg.getBoundingClientRect();
      modal.setAttribute('data-zone-map-panning', 'true');

      if (typeof stage.setPointerCapture === 'function') {
        try {
          stage.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture can fail in older browsers. Dragging still works while over the stage.
        }
      }

      event.preventDefault();
    });

    stage.addEventListener('pointermove', function(event) {
      var state = getState(modal);
      if (state.activePointers && state.activePointers[String(event.pointerId)]) {
        state.activePointers[String(event.pointerId)] = {
          clientX: event.clientX,
          clientY: event.clientY
        };
      }

      if (state.isPinching) {
        var pointers = getActivePointerList(state);
        if (pointers.length >= 2 && state.pinchStartDistance > 0) {
          var distance = getPointerDistance(pointers[0], pointers[1]);
          var nextZoom = state.pinchStartZoom * (distance / state.pinchStartDistance);
          setMapZoom(modal, nextZoom, state.pinchStartAnchor, { animate: false, updateControls: false });
          event.preventDefault();
        }
        return;
      }

      if (!state.isPanning || state.panPointerId !== event.pointerId || !state.panStartViewBox || !state.svg) return;

      state.panLatestClientX = event.clientX;
      state.panLatestClientY = event.clientY;
      schedulePendingMapPan(modal);
      event.preventDefault();
    });

    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function(eventName) {
      stage.addEventListener(eventName, function(event) {
        var state = getState(modal);
        if (state.activePointers) {
          delete state.activePointers[String(event.pointerId)];
        }
        if (state.isPinching && getActivePointerList(state).length < 2) {
          resetPinchState(modal);
          updateZoomControls(modal);
        }
        endMapPan(modal, stage, event.pointerId);
      });
    });
  }

  function getProductRange(modal) {
    if (!modal) return null;
    var stored = readJsonAttribute(modal, 'data-zone-map-product-range');
    if (stored) return stored;
    var source = modal.getAttribute('data-zone-map-source') || '';
    var description = modal.getAttribute('data-zone-map-description') || '';
    return parseRange(source) || parseRangeFromText(source) || parseRangeFromText(description);
  }

  function getUserRange(modal) {
    if (!modal) return null;
    var stored = readJsonAttribute(modal, 'data-zone-map-user-range');
    if (stored) return stored;
    var saved = getSavedZone();
    return parseRange(saved);
  }

  function syncTriggerState(modal) {
    if (!modal || !modal.id) return null;
    var range = getProductRange(modal);
    var triggers = document.querySelectorAll('[data-zone-map-trigger][aria-controls="' + modal.id + '"]');
    triggers.forEach(function(trigger) {
      var enabled = Boolean(range);
      trigger.setAttribute('aria-haspopup', 'dialog');
      if (!trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('data-zone-map-enabled', enabled ? 'true' : 'false');
      trigger.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if ('disabled' in trigger) {
        trigger.disabled = !enabled;
      }
    });
    modal.setAttribute('data-zone-map-enabled', range ? 'true' : 'false');
    return range;
  }

  function setModalTriggerExpanded(modal, expanded) {
    if (!modal || !modal.id) return;
    Array.prototype.slice.call(document.querySelectorAll('[data-zone-map-trigger][aria-controls="' + modal.id + '"]')).forEach(function(trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function isFocusable(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.tabIndex < 0) return false;
    if (element.offsetParent === null && element !== document.activeElement) return false;
    return true;
  }

  function getFocusableElements(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(isFocusable);
  }

  function focusInitialModalControl(modal) {
    if (!modal || isStandaloneMap(modal)) return;
    var initial = modal.querySelector('button[data-zone-map-close]') || getFocusableElements(modal)[0];
    if (!initial || typeof initial.focus !== 'function') return;
    window.requestAnimationFrame(function() {
      try {
        initial.focus({ preventScroll: true });
      } catch (error) {
        initial.focus();
      }
    });
  }

  function trapModalFocus(modal, event) {
    if (!modal || isStandaloneMap(modal) || event.key !== 'Tab') return;
    var focusable = getFocusableElements(modal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function syncSourceDisclosureState(modal) {
    if (!modal) return;
    Array.prototype.slice.call(modal.querySelectorAll('.product-zone-map-modal__source')).forEach(function(details, index) {
      var summary = details.querySelector('.product-zone-map-modal__source-trigger');
      var text = details.querySelector('.product-zone-map-modal__source-text');
      if (!summary || !text) return;
      if (!text.id && modal.id) {
        text.id = modal.id + '-source-copy-' + index;
      }
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (text.id) {
        summary.setAttribute('aria-controls', text.id);
      }
      if (details.dataset.zoneMapSourceBound !== 'true') {
        details.dataset.zoneMapSourceBound = 'true';
        details.addEventListener('toggle', function() {
          summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
      }
    });
  }

  function updateModalCopy(modal, productRange, userRange) {
    var rangeSummary = modal.querySelector('[data-zone-map-range-summary]');
    var userSummary = modal.querySelector('[data-zone-map-user-summary]');

    if (rangeSummary) {
      rangeSummary.textContent = productRange ? ('Zones ' + formatRange(productRange)) : 'Zone details unavailable';
    }

    if (userSummary) {
      userSummary.textContent = userRange ? ('Your zone: ' + formatRange(userRange)) : 'Set your zone';
    }

    updatePickerButton(modal, userRange);
  }

  function syncActionBarVisibility(modal) {
    var actions = modal && modal.querySelector('.product-zone-map-modal__actions');
    if (!actions) return;

    var hasVisibleAction = Array.prototype.slice.call(actions.children).some(function(child) {
      return child instanceof HTMLElement && !child.hidden;
    });
    actions.hidden = !hasVisibleAction;
  }

  function updatePickerButton(modal, userRange) {
    var pickerButton = modal.querySelector('[data-zone-map-zone-picker]');
    if (!pickerButton) {
      syncActionBarVisibility(modal);
      return;
    }

    var state = getState(modal);
    var selected = (state.searchLocation && state.searchLocation.zone) || '';
    var selectedLabel = selected ? String(selected).toUpperCase() : '';
    var userLabel = userRange ? formatRange(userRange).toUpperCase() : '';
    var currentUserSingle = userRange && userRange.minIndex === userRange.maxIndex && userRange.minLabel
      ? String(userRange.minLabel).toLowerCase()
      : '';

    pickerButton.classList.add('product-zone-map-modal__action');
    pickerButton.classList.remove('product-zone-map-modal__action--secondary');

    if (state.pickerSavedRecently && selected && selected === state.pickerSavedRecently) {
      pickerButton.hidden = false;
      pickerButton.setAttribute('data-zone-map-save-state', 'saved');
      pickerButton.disabled = false;
      pickerButton.textContent = 'Saved Zone ' + selectedLabel;
      syncActionBarVisibility(modal);
      return;
    }

    if (!selected) {
      pickerButton.setAttribute('data-zone-map-save-state', 'idle');
      pickerButton.classList.add('product-zone-map-modal__action--secondary');
      pickerButton.disabled = true;
      pickerButton.hidden = true;
      pickerButton.textContent = userRange
        ? 'Search an address to compare it with Zone ' + userLabel
        : 'Search an address to check its zone';
      syncActionBarVisibility(modal);
      return;
    }

    pickerButton.hidden = false;
    if (currentUserSingle && currentUserSingle === selected) {
      pickerButton.setAttribute('data-zone-map-save-state', 'saved');
      pickerButton.classList.add('product-zone-map-modal__action--secondary');
      pickerButton.disabled = false;
      pickerButton.textContent = 'Zone ' + selectedLabel + ' is your saved zone';
      syncActionBarVisibility(modal);
      return;
    }

    pickerButton.setAttribute('data-zone-map-save-state', 'armed');
    pickerButton.disabled = false;
    pickerButton.textContent = 'Save Zone ' + selectedLabel;
    syncActionBarVisibility(modal);
  }

  function handleSaveCurrentZone(modal) {
    var state = getState(modal);
    var selected = (state.searchLocation && state.searchLocation.zone) || '';
    if (!selected) {
      setSearchStatus(modal, 'Search an address first, then save that USDA zone.', 'error');
      return;
    }

    var normalizedZone = formatSingleZone(selected);
    if (!normalizedZone) {
      setSearchStatus(modal, 'That zone could not be saved. Try another zone.', 'error');
      return;
    }

    var zipClimate = window.MrMapleZipClimate;
    var searchLoc = state.searchLocation;
    var savePromise;

    if (searchLoc && searchLoc.zip && zipClimate && typeof zipClimate.lookupZipClimate === 'function') {
      // ZIP-based search: persist zone + heat profile in one pass.
      savePromise = zipClimate.lookupZipClimate(searchLoc.zip).then(function() { return normalizedZone; });
    } else if (zipClimate && typeof zipClimate.persistZone === 'function') {
      savePromise = Promise.resolve(zipClimate.persistZone(normalizedZone));
    } else {
      // Fallback: write the storage keys directly so the rest of the site picks it up.
      try { localStorage.setItem('usdaZone', normalizedZone); } catch (error) {}
      try { localStorage.setItem('mrmaple_zone', normalizedZone); } catch (error) {}
      try { localStorage.setItem('usdaZone_ts', String(Date.now())); } catch (error) {}
      try {
        window.dispatchEvent(new CustomEvent('garden:zone-updated', { detail: { zone: normalizedZone } }));
      } catch (error) {}
      savePromise = Promise.resolve(normalizedZone);
    }

    setSearchStatus(modal, 'Saving Zone ' + normalizedZone.toUpperCase() + ' to your profile...', 'loading');

    savePromise.then(function() {
      state.pickerSavedRecently = normalizedZone;
      setSearchStatus(modal, 'Zone ' + normalizedZone.toUpperCase() + ' is now your saved zone.', 'success');
      updateModal(modal);
      window.setTimeout(function() {
        if (state.pickerSavedRecently === normalizedZone) {
          state.pickerSavedRecently = '';
          updatePickerButton(modal, getUserRange(modal));
        }
      }, 2600);
    }).catch(function() {
      setSearchStatus(modal, 'We could not save that zone. Please try again.', 'error');
    });
  }

  function formatSingleZone(zoneLabel) {
    var match = String(zoneLabel || '').toLowerCase().match(/^([1-9]|1[0-3])([ab])$/);
    return match ? (match[1] + match[2]) : '';
  }

  function createSearchIconElement() {
    var icon = document.createElementNS(SVG_NS, 'svg');
    icon.setAttribute('class', 'product-zone-map-modal__action-icon');
    icon.setAttribute('viewBox', '0 0 20 20');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');

    var circle = document.createElementNS(SVG_NS, 'circle');
    circle.setAttribute('cx', '8.5');
    circle.setAttribute('cy', '8.5');
    circle.setAttribute('r', '5.25');

    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', 'M12.5 12.5L17 17');

    icon.appendChild(circle);
    icon.appendChild(path);
    return icon;
  }

  function ensureSearchDock(modal) {
    var tray = ensureMapControlTray(modal);
    if (!tray) return null;

    var dock = tray.querySelector('[data-zone-map-search-dock]');
    if (!dock) {
      dock = document.createElement('div');
      dock.className = 'product-zone-map-modal__search-dock';
      dock.setAttribute('data-zone-map-search-dock', '');
    }

    var locationButton = tray.querySelector('[data-zone-map-location-focus]');
    var source = tray.querySelector('.product-zone-map-modal__source');
    var anchor = locationButton || source || null;

    if (dock.parentNode !== tray) {
      if (anchor) {
        tray.insertBefore(dock, anchor);
      } else {
        tray.appendChild(dock);
      }
    } else if (anchor && anchor.parentNode === tray && dock.nextElementSibling !== anchor) {
      tray.insertBefore(dock, anchor);
    }

    return dock;
  }

  function syncSearchToggleState(modal) {
    var state = getState(modal);
    var isOpen = modal.getAttribute('data-zone-map-search-open') === 'true';

    if (state.searchPanel) {
      state.searchPanel.hidden = !isOpen;
    }

    if (state.searchToggleButton) {
      state.searchToggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  }

  function setSearchStatus(modal, message, type) {
    var state = getState(modal);
    var status = state.searchStatus || (modal && modal.querySelector('[data-zone-map-search-status]'));
    var normalizedType = type || 'idle';

    modal.setAttribute('data-zone-map-search-state', normalizedType);

    if (status) {
      status.textContent = message || '';
      status.hidden = !message;
      status.setAttribute('data-zone-map-search-status-type', normalizedType);
    }
  }

  function setSearchOpen(modal, isOpen, options) {
    var state = getState(modal);
    ensureSearchControls(modal);
    var panel = state.searchPanel;
    if (!panel) return;

    var nextOpen = Boolean(isOpen);
    panel.hidden = !nextOpen;
    modal.setAttribute('data-zone-map-search-open', nextOpen ? 'true' : 'false');
    syncSearchToggleState(modal);

    if (nextOpen && (!options || options.focus !== false)) {
      window.setTimeout(function() {
        if (state.searchInput && typeof state.searchInput.focus === 'function') {
          state.searchInput.focus({ preventScroll: true });
        }
      }, 60);
    }
  }

  function ensureSearchControls(modal) {
    if (!modal) return;
    var state = getState(modal);
    var sheet = modal.querySelector('.product-zone-map-modal__sheet');
    if (!sheet) return;

    var actions = ensureActionBar(modal) || sheet;
    ensureSourcePlacement(modal);
    var searchDock = ensureSearchDock(modal);
    if (!searchDock) return;

    var panel = modal.querySelector('[data-zone-map-search]');

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'product-zone-map-modal__search';
      panel.setAttribute('data-zone-map-search', '');
      panel.hidden = true;
      if (modal.id) {
        panel.id = modal.id + '-search';
      }

      var form = document.createElement('form');
      form.className = 'product-zone-map-modal__search-form';
      form.setAttribute('data-zone-map-search-form', '');

      var label = document.createElement('label');
      label.className = 'product-zone-map-modal__search-label';
      label.textContent = 'Address or ZIP';

      var input = document.createElement('input');
      input.className = 'product-zone-map-modal__search-input';
      input.setAttribute('data-zone-map-search-input', '');
      input.type = 'search';
      input.autocomplete = 'street-address';
      input.placeholder = 'Search address, city, or ZIP';
      if (modal.id) {
        input.id = modal.id + '-search-input';
        label.setAttribute('for', input.id);
      }

      var submit = document.createElement('button');
      submit.className = 'product-zone-map-modal__search-submit';
      submit.setAttribute('data-zone-map-search-submit', '');
      submit.type = 'submit';
      submit.textContent = 'Search';

      var row = document.createElement('div');
      row.className = 'product-zone-map-modal__search-row';
      row.appendChild(input);
      row.appendChild(submit);

      var results = document.createElement('div');
      results.className = 'product-zone-map-modal__search-results';
      results.setAttribute('data-zone-map-search-results', '');
      results.setAttribute('role', 'listbox');
      results.hidden = true;

      var status = document.createElement('p');
      status.className = 'product-zone-map-modal__search-status';
      status.setAttribute('data-zone-map-search-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.hidden = true;

      form.appendChild(label);
      form.appendChild(row);
      form.appendChild(results);
      form.appendChild(status);
      panel.appendChild(form);

    }

    var toggle = searchDock.querySelector('[data-zone-map-search-toggle]');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'product-zone-map-modal__search-toggle';
      toggle.setAttribute('data-zone-map-search-toggle', '');
      toggle.setAttribute('aria-label', 'Search address or ZIP');
      toggle.appendChild(createSearchIconElement());
      searchDock.appendChild(toggle);
    }

    if (panel.parentNode !== searchDock) {
      searchDock.appendChild(panel);
    }

    if (searchDock.firstElementChild !== toggle) {
      searchDock.insertBefore(toggle, searchDock.firstChild);
    }

    if (panel.id) {
      toggle.setAttribute('aria-controls', panel.id);
    }

    var pickerButton = actions.querySelector('[data-zone-map-zone-picker]');
    if (pickerButton) {
      pickerButton.classList.add('product-zone-map-modal__action');
      if (!pickerButton.hasAttribute('data-zone-map-save-state')) {
        pickerButton.setAttribute('data-zone-map-save-state', 'idle');
      }
    }

    state.searchPanel = panel;
    state.searchToggleButton = toggle;
    state.searchInput = panel.querySelector('[data-zone-map-search-input]');
    state.searchStatus = panel.querySelector('[data-zone-map-search-status]');
    state.searchSubmitButton = panel.querySelector('[data-zone-map-search-submit]');
    state.searchResultsElement = panel.querySelector('[data-zone-map-search-results]');

    var formElement = panel.querySelector('[data-zone-map-search-form]');
    if (formElement && formElement.getAttribute('data-zone-map-search-bound') !== 'true') {
      formElement.setAttribute('data-zone-map-search-bound', 'true');
      formElement.addEventListener('submit', function(event) {
        handleSearchSubmit(modal, event);
      });
    }

    if (!modal.hasAttribute('data-zone-map-search-open')) {
      modal.setAttribute('data-zone-map-search-open', 'false');
    }
    if (!modal.hasAttribute('data-zone-map-search-state')) {
      modal.setAttribute('data-zone-map-search-state', 'idle');
    }
    syncSearchToggleState(modal);
  }

  function parseCoordinateSearch(raw) {
    var match = String(raw || '').trim().match(/^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)$/);
    if (!match) return null;

    var latitude = parseFloat(match[1]);
    var longitude = parseFloat(match[2]);
    if (!isFinite(latitude) || !isFinite(longitude)) return null;
    if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;

    return {
      latitude: latitude,
      longitude: longitude,
      label: latitude.toFixed(4) + ', ' + longitude.toFixed(4),
      source: 'coordinates'
    };
  }

  function summarizeSearchLabel(raw) {
    var text = normalizeText(raw);
    if (!text) return 'That location';

    var parts = text.split(',').map(function(part) {
      return normalizeText(part);
    }).filter(Boolean);

    if (parts.length > 3) {
      return parts.slice(0, 3).join(', ');
    }

    return text;
  }

  function normalizeGeocodeResult(result, fallbackLabel, cacheKey) {
    if (!result) return null;

    var latitude = parseFloat(result.lat);
    var longitude = parseFloat(result.lon);
    if (!isFinite(latitude) || !isFinite(longitude)) return null;

    var zip = '';
    if (result.address && result.address.postcode) {
      var zipMatch = String(result.address.postcode).match(/\b\d{5}(?:-\d{4})?\b/);
      zip = zipMatch ? zipMatch[0].slice(0, 5) : '';
    }

    return {
      latitude: latitude,
      longitude: longitude,
      label: result.display_name || fallbackLabel,
      zip: zip,
      source: 'address',
      cacheKey: cacheKey
    };
  }

  function cacheSearchLocations(cacheKey, locations) {
    var cache = getRuntimeCache();
    var normalized = Array.isArray(locations) ? locations.filter(Boolean) : [];
    cache.addressLocationCache[cacheKey] = normalized;
    return normalized;
  }

  function lookupSearchLocations(query) {
    var normalizedQuery = normalizeLocationSearchText(query);
    var cacheKey = normalizedQuery.toLowerCase();
    var cache = getRuntimeCache();

    if (!normalizedQuery) return Promise.resolve([]);
    if (cache.addressLocationCache[cacheKey]) {
      var cachedLocations = cache.addressLocationCache[cacheKey];
      return Promise.resolve(Array.isArray(cachedLocations) ? cachedLocations : [cachedLocations]);
    }

    var coordinateResult = parseCoordinateSearch(normalizedQuery);
    if (coordinateResult) {
      coordinateResult.cacheKey = cacheKey;
      return Promise.resolve(cacheSearchLocations(cacheKey, [coordinateResult]));
    }

    var exactZipMatch = normalizedQuery.match(/^\d{5}(?:-\d{4})?$/);
    if (exactZipMatch) {
      var zipCode = exactZipMatch[0].slice(0, 5);
      if (cache.zipLocationCache[zipCode]) {
        var cachedZip = {
          latitude: cache.zipLocationCache[zipCode].latitude,
          longitude: cache.zipLocationCache[zipCode].longitude,
          label: cache.zipLocationCache[zipCode].label || ('ZIP ' + zipCode),
          zip: zipCode,
          source: 'zip',
          cacheKey: cacheKey
        };
        return Promise.resolve(cacheSearchLocations(cacheKey, [cachedZip]));
      }

      return fetch('https://api.zippopotam.us/us/' + encodeURIComponent(zipCode), { cache: 'force-cache' })
        .then(function(response) {
          if (!response.ok) throw new Error('Failed to lookup ZIP location');
          return response.json();
        })
        .then(function(data) {
          var place = data && data.places && data.places[0];
          if (!place) return null;

          var latitude = parseFloat(place.latitude);
          var longitude = parseFloat(place.longitude);
          if (!isFinite(latitude) || !isFinite(longitude)) return null;

          var placeLabel = [place['place name'], place['state abbreviation']].filter(Boolean).join(', ');
          var location = {
            latitude: latitude,
            longitude: longitude,
            label: placeLabel || ('ZIP ' + zipCode),
            zip: zipCode,
            source: 'zip',
            cacheKey: cacheKey
          };

          cache.zipLocationCache[zipCode] = {
            latitude: latitude,
            longitude: longitude,
            label: location.label
          };
          return cacheSearchLocations(cacheKey, [location]);
        });
    }

    var config = window.MrMapleZoneMapConfig || {};
    var geocodeUrl = config.searchGeocodeUrl || SEARCH_GEOCODE_URL;

    return fetch(
      geocodeUrl +
        '?format=json&addressdetails=1&limit=5&countrycodes=us&q=' +
        encodeURIComponent(normalizedQuery),
      {
        cache: 'force-cache',
        headers: { Accept: 'application/json' }
      }
    )
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to lookup address');
        return response.json();
      })
      .then(function(data) {
        var locations = Array.isArray(data)
          ? data.map(function(result) {
            return normalizeGeocodeResult(result, normalizedQuery, cacheKey);
          }).filter(Boolean).slice(0, 5)
          : [];
        return cacheSearchLocations(cacheKey, locations);
      });
  }

  function lookupSearchLocation(query) {
    return lookupSearchLocations(query).then(function(locations) {
      return locations[0] || null;
    });
  }

  function isProjectedPointInsideMap(modal, point) {
    var state = getState(modal);
    var box = state.baseViewBox;
    if (!box || !point) return false;

    var margin = 18;
    return (
      point.x >= box.x - margin &&
      point.x <= box.x + box.width + margin &&
      point.y >= box.y - margin &&
      point.y <= box.y + box.height + margin
    );
  }

  function getSearchRangeVerdict(zoneLabel, productRange) {
    var zoneIndex = zoneToIndex(zoneLabel);
    if (!productRange || zoneIndex < 1) {
      return 'Plant growing range unavailable.';
    }
    return rangeContainsIndex(productRange, zoneIndex)
      ? 'Within this plant\'s growing range.'
      : 'Outside this plant\'s growing range.';
  }

  function buildSearchResultMessage(label, zoneLabel, productRange) {
    var displayZone = formatSingleZone(zoneLabel);
    var displayLabel = summarizeSearchLabel(label);
    return displayLabel + ' is USDA Zone ' + displayZone.toUpperCase() + '. ' +
      getSearchRangeVerdict(zoneLabel, productRange);
  }

  function clearSearchResults(modal) {
    var state = getState(modal);
    state.searchResults = [];
    if (!state.searchResultsElement) return;
    state.searchResultsElement.innerHTML = '';
    state.searchResultsElement.hidden = true;
  }

  function renderSearchResults(modal, locations, query) {
    var state = getState(modal);
    var results = state.searchResultsElement;
    if (!results) return;

    results.innerHTML = '';
    state.searchResults = Array.isArray(locations) ? locations.slice(0, 3) : [];
    results.hidden = !state.searchResults.length;

    state.searchResults.forEach(function(location, index) {
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'product-zone-map-modal__search-result';
      option.setAttribute('data-zone-map-search-result-option', String(index));
      option.setAttribute('role', 'option');
      option.textContent = summarizeSearchLabel(location.label || query);
      option.addEventListener('click', function() {
        applySearchLocation(modal, location, query);
      });
      results.appendChild(option);
    });
  }

  function applySearchLocation(modal, location, query) {
    var state = getState(modal);
    if (!location) return null;

    var point = projectLonLatToSvg(state.svg, location.longitude, location.latitude);
    if (!isProjectedPointInsideMap(modal, point)) {
      setSearchStatus(modal, 'That location is outside this lower-48 USDA map.', 'error');
      return null;
    }

    var zoneLabel = getZoneLabelForProjectedPoint(modal, point);
    var displayZone = formatSingleZone(zoneLabel);
    if (!displayZone) {
      setSearchStatus(modal, 'We found the place, but could not match it to a zone.', 'error');
      return null;
    }

    var label = summarizeSearchLabel(location.label || query);
    var productRange = getProductRange(modal);
    var message = buildSearchResultMessage(label, zoneLabel, productRange);

    state.searchLocation = {
      latitude: location.latitude,
      longitude: location.longitude,
      label: label,
      zone: zoneLabel,
      zip: location.zip || '',
      source: location.source || 'address',
      cacheKey: location.cacheKey || String(query || label).toLowerCase(),
      message: message,
      inRange: rangeContainsIndex(productRange, zoneToIndex(zoneLabel))
    };

    modal.setAttribute('data-zone-map-search-result', 'true');
    modal.setAttribute('data-zone-map-search-zone', zoneLabel);
    state.selectedZone = '';
    state.pickerSavedRecently = '';
    setLinkedActiveZone(modal, zoneLabel);
    clearSearchResults(modal);
    if (state.searchInput && state.searchInput.value !== label) {
      state.searchInput.value = label;
    }
    renderLegend(modal, productRange, getUserRange(modal));
    updateMapState(modal, productRange, getUserRange(modal));
    showTooltip(modal, message);
    focusMapOnPoint(modal, point, SEARCH_RESULT_ZOOM, { animate: true, duration: 680 });

    var queryZip = extractZipCode(query);
    if (queryZip) {
      state.searchLocation.zip = queryZip;
    }

    setSearchStatus(modal, message, 'success');
    updatePickerButton(modal, getUserRange(modal));
    return state.searchLocation;
  }

  function handleSearchSubmit(modal, event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    ensureSearchControls(modal);
    var state = getState(modal);
    var input = state.searchInput;
    var query = normalizeText(input && input.value);

    if (!query) {
      setSearchStatus(modal, 'Enter a city, address, or ZIP code.', 'error');
      if (input && typeof input.focus === 'function') input.focus();
      return;
    }

    state.searchLookupQuery = query;
    state.searchLocation = null;
    modal.setAttribute('data-zone-map-search-result', 'false');
    modal.removeAttribute('data-zone-map-search-zone');
    clearSearchResults(modal);
    clearLinkedActiveZone(modal, '', { force: true });
    showTooltip(modal, '');
    renderLegend(modal, getProductRange(modal), getUserRange(modal));
    updateMapState(modal, getProductRange(modal), getUserRange(modal));
    updatePickerButton(modal, getUserRange(modal));
    setSearchStatus(modal, 'Searching for ' + query + '...', 'loading');
    if (state.searchSubmitButton) state.searchSubmitButton.disabled = true;

    state.searchLookupPromise = ensureInlineMap(modal)
      .then(function() {
        return lookupSearchLocations(query);
      })
      .then(function(locations) {
        if (state.searchLookupQuery !== query) return null;
        if (!locations || !locations.length) {
          setSearchStatus(modal, 'We could not find that city or address.', 'error');
          return null;
        }

        if (locations.length === 1 || locations[0].source === 'zip' || locations[0].source === 'coordinates') {
          return applySearchLocation(modal, locations[0], query);
        }

        renderSearchResults(modal, locations, query);
        setSearchStatus(modal, 'Select an address to place the marker.', 'success');
        return null;
      })
      .catch(function() {
        if (state.searchLookupQuery === query) {
          setSearchStatus(modal, 'There was a problem looking up that location.', 'error');
        }
        return null;
      })
      .finally(function() {
        if (state.searchSubmitButton) state.searchSubmitButton.disabled = false;
      });
  }

  function getTooltipElement(modal) {
    if (!modal) return null;
    var state = getState(modal);
    if (state.tooltipElement && state.tooltipElement.parentNode) return state.tooltipElement;
    state.tooltipElement = modal && modal.querySelector('.product-zone-map-modal__tooltip[data-zone-map-tooltip]');
    return state.tooltipElement;
  }

  function getTooltipStage(modal) {
    if (!modal) return null;
    var state = getState(modal);
    if (state.tooltipStage && state.tooltipStage.parentNode) return state.tooltipStage;
    state.tooltipStage = modal && modal.querySelector('.product-zone-map-modal__stage');
    state.tooltipStageRect = null;
    state.tooltipStageRectAt = 0;
    return state.tooltipStage;
  }

  function getTooltipStageRect(modal) {
    var state = getState(modal);
    var stage = getTooltipStage(modal);
    if (!stage || typeof stage.getBoundingClientRect !== 'function') return null;

    var now = Date.now();
    if (!state.tooltipStageRect || now - state.tooltipStageRectAt > 250) {
      state.tooltipStageRect = stage.getBoundingClientRect();
      state.tooltipStageRectAt = now;
    }

    return state.tooltipStageRect;
  }

  function clearPendingTooltipPosition(state) {
    if (!state) return;
    if (state.tooltipPositionFrame) {
      window.cancelAnimationFrame(state.tooltipPositionFrame);
      state.tooltipPositionFrame = null;
    }
    state.pendingTooltipPoint = null;
  }

  function positionTooltip(modal, clientX, clientY) {
    var tooltip = getTooltipElement(modal);
    if (!tooltip || typeof clientX !== 'number' || typeof clientY !== 'number') return;

    var state = getState(modal);
    var rect = getTooltipStageRect(modal);
    if (!rect) return;
    if (!rect.width || !rect.height) return;

    var rawX = clientX - rect.left;
    var rawY = clientY - rect.top;
    var inset = 18;
    var maxX = Math.max(inset, rect.width - inset);
    var maxY = Math.max(inset, rect.height - inset);
    var x = Math.min(Math.max(rawX, inset), maxX);
    var placeBelow = rawY < 56;
    var y = placeBelow
      ? Math.min(Math.max(rawY + 14, inset), maxY)
      : Math.min(Math.max(rawY - 14, inset), maxY);
    var nextX = x.toFixed(1) + 'px';
    var nextY = y.toFixed(1) + 'px';
    var nextBelow = placeBelow ? 'true' : 'false';

    if (state.tooltipLastX !== nextX) {
      tooltip.style.setProperty('--zone-map-tooltip-x', nextX);
      state.tooltipLastX = nextX;
    }
    if (state.tooltipLastY !== nextY) {
      tooltip.style.setProperty('--zone-map-tooltip-y', nextY);
      state.tooltipLastY = nextY;
    }
    if (state.tooltipLastBelow !== nextBelow) {
      tooltip.setAttribute('data-zone-map-tooltip-below', nextBelow);
      state.tooltipLastBelow = nextBelow;
    }
  }

  function scheduleTooltipPosition(modal, clientX, clientY) {
    var state = getState(modal);
    if (typeof clientX !== 'number' || typeof clientY !== 'number') return;

    state.pendingTooltipPoint = { clientX: clientX, clientY: clientY };
    if (state.tooltipPositionFrame) return;

    state.tooltipPositionFrame = window.requestAnimationFrame(function() {
      var point = state.pendingTooltipPoint;
      state.tooltipPositionFrame = null;
      state.pendingTooltipPoint = null;
      if (point) {
        positionTooltip(modal, point.clientX, point.clientY);
      }
    });
  }

  function positionTooltipForPath(modal, path) {
    if (!path || typeof path.getBoundingClientRect !== 'function') return;
    var rect = path.getBoundingClientRect();
    if (!rect.width && !rect.height) return;
    positionTooltip(modal, rect.left + (rect.width / 2), rect.top + (rect.height / 2));
  }

  function showTooltip(modal, message, options) {
    var tooltip = getTooltipElement(modal);
    if (!tooltip) return;
    var state = getState(modal);
    var nextMessage = message || '';
    if (options && typeof options.clientX === 'number' && typeof options.clientY === 'number') {
      if (state.tooltipMessage === nextMessage) {
        scheduleTooltipPosition(modal, options.clientX, options.clientY);
      } else {
        positionTooltip(modal, options.clientX, options.clientY);
      }
    }
    if (state.tooltipMessage === nextMessage) return;
    state.tooltipMessage = nextMessage;
    tooltip.hidden = !nextMessage;
    tooltip.textContent = nextMessage;
    if (!nextMessage) {
      clearPendingTooltipPosition(state);
      tooltip.removeAttribute('data-zone-map-tooltip-below');
      tooltip.style.removeProperty('--zone-map-tooltip-x');
      tooltip.style.removeProperty('--zone-map-tooltip-y');
      state.tooltipLastX = '';
      state.tooltipLastY = '';
      state.tooltipLastBelow = '';
    }
  }

  function buildVisibleZoneTooltipText(zoneLabel) {
    var displayZone = formatSingleZone(zoneLabel);
    return displayZone ? ('Zone ' + displayZone) : '';
  }

  function buildTooltipText(zoneLabel, productRange, userRange, temperatureRange) {
    var zoneIndex = zoneToIndex(zoneLabel);
    var details = [buildVisibleZoneTooltipText(zoneLabel) || ('Zone ' + String(zoneLabel || '').toUpperCase())];

    if (temperatureRange) {
      details.push('Average annual extreme minimum: ' + temperatureRange + 'F.');
    }

    var matchesUser = rangeContainsIndex(userRange, zoneIndex);
    var matchesPlant = rangeContainsIndex(productRange, zoneIndex);

    if (matchesPlant) {
      details.push('Within this plant\'s growing range.');
    } else if (productRange) {
      details.push('Outside this plant\'s growing range.');
    } else {
      details.push('Plant growing range unavailable.');
    }

    if (matchesUser) {
      details.push('This is your saved growing zone.');
    }

    return details.join(' ');
  }

  // A single dedicated highlight path is appended above every zone/state border
  // so the active outline is never clipped by a neighbor's border. Copying the
  // active zone's "d" into it (rather than reparenting the real path) keeps
  // hover/search snappy and avoids touching the zones group.
  function ensureHighlightPath(modal) {
    var state = getState(modal);
    if (!state.svg) return null;
    if (state.highlightPath && state.highlightPath.parentNode) return state.highlightPath;

    var path = state.svg.querySelector('[data-zone-map-highlight]');
    if (!path) {
      path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('class', 'usda-zone-map__zone-highlight');
      path.setAttribute('data-zone-map-highlight', '');
      path.setAttribute('aria-hidden', 'true');
      path.setAttribute('fill-rule', 'evenodd');
      path.setAttribute('pointer-events', 'none');

      var markerLayer = state.svg.querySelector('[data-zone-map-marker-layer]');
      if (markerLayer && markerLayer.parentNode === state.svg) {
        state.svg.insertBefore(path, markerLayer);
      } else {
        state.svg.appendChild(path);
      }
    }

    state.highlightPath = path;
    return path;
  }

  function setZoneHighlight(modal, zoneLabel) {
    var state = getState(modal);
    var path = ensureHighlightPath(modal);
    if (!path) return;

    var normalizedZone = String(zoneLabel || '').toLowerCase();
    if (!normalizedZone) {
      path.removeAttribute('d');
      path.removeAttribute('data-highlight-zone');
      path.classList.remove('is-visible');
      state.highlightZone = '';
      return;
    }

    var source = state.zonePathsByZone && state.zonePathsByZone[normalizedZone];
    var pathData = source && source.getAttribute('d');
    if (!pathData) return;

    path.setAttribute('d', pathData);
    path.setAttribute('data-highlight-zone', normalizedZone);
    path.classList.add('is-visible');
    state.highlightZone = normalizedZone;
  }

  function clearZoneHighlight(modal, zoneLabel) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();
    if (normalizedZone && state.highlightZone && state.highlightZone !== normalizedZone) return;
    setZoneHighlight(modal, '');
  }

  function syncZoneSelectValue(modal, zoneLabel) {
    return null;
  }

  function applyLinkedZoneState(modal, zoneLabel, isActive) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();
    if (!normalizedZone) return;

    var path = state.zonePathsByZone && state.zonePathsByZone[normalizedZone];
    if (path) {
      path.classList.toggle('is-linked-active', isActive);
    }

    if (isActive) {
      setZoneHighlight(modal, normalizedZone);
    } else {
      clearZoneHighlight(modal, normalizedZone);
    }

    var chip = state.legendChipsByZone && state.legendChipsByZone[normalizedZone];
    if (chip) {
      chip.classList.toggle('is-linked-active', isActive);
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }

  }

  function isLegendChipVisible(chip) {
    var parent = chip && chip.parentElement;
    if (!chip || !parent) return true;
    var chipRect = chip.getBoundingClientRect();
    var parentRect = parent.getBoundingClientRect();
    return (
      chipRect.left >= parentRect.left &&
      chipRect.right <= parentRect.right &&
      chipRect.top >= parentRect.top &&
      chipRect.bottom <= parentRect.bottom
    );
  }

  function revealLinkedLegendChip(modal, zoneLabel, options) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();

    var select = syncZoneSelectValue(modal, normalizedZone);

    var chip = state.legendChipsByZone && state.legendChipsByZone[normalizedZone];
    if (!chip) {
      if (select && options && options.focus === true && typeof select.focus === 'function') {
        try {
          select.focus({ preventScroll: true });
        } catch (error) {
          select.focus();
        }
      }
      return;
    }

    var shouldScroll = !options || options.scroll !== false;
    if (shouldScroll && typeof chip.scrollIntoView === 'function' && !isLegendChipVisible(chip)) {
      chip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    if (options && options.focus === true && typeof chip.focus === 'function') {
      try {
        chip.focus({ preventScroll: true });
      } catch (error) {
        chip.focus();
      }
    }
  }

  function focusLinkedMapPath(modal, zoneLabel) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();
    var path = state.zonePathsByZone && state.zonePathsByZone[normalizedZone];
    if (path && typeof path.focus === 'function') {
      try {
        path.focus({ preventScroll: true });
      } catch (error) {
        path.focus();
      }
      applyLinkedZoneState(modal, normalizedZone, true);
      syncZoneSelectValue(modal, normalizedZone);
    }
  }

  function setLinkedActiveZone(modal, zoneLabel) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();
    if (!normalizedZone) return;
    if (state.activeZone === normalizedZone) {
      applyLinkedZoneState(modal, normalizedZone, true);
      return;
    }

    if (state.activeZone && state.activeZone !== normalizedZone) {
      applyLinkedZoneState(modal, state.activeZone, false);
    }

    state.activeZone = normalizedZone;
    applyLinkedZoneState(modal, normalizedZone, true);
  }

  function selectLinkedActiveZone(modal, zoneLabel, source) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();
    if (!normalizedZone) return;

    state.selectedZone = normalizedZone;
    state.pickerSavedRecently = '';
    syncZoneSelectValue(modal, normalizedZone);
    if (source === 'legend') {
      state.pendingHoverPath = null;
      state.suppressMapHoverUntil = Date.now() + 300;
    }
    setLinkedActiveZone(modal, normalizedZone);
    updatePickerButton(modal, getUserRange(modal));

    if (source === 'map') {
      revealLinkedLegendChip(modal, normalizedZone, { focus: true });
    } else if (source === 'map-touch') {
      revealLinkedLegendChip(modal, normalizedZone, { focus: false, scroll: false });
    } else if (source === 'legend') {
      focusLinkedMapPath(modal, normalizedZone);
    }
  }

  function clearLinkedActiveZone(modal, zoneLabel, options) {
    var state = getState(modal);
    var normalizedZone = String(zoneLabel || '').toLowerCase();
    var force = options && options.force === true;

    if (!state.activeZone) {
      if (force) state.selectedZone = '';
      return;
    }
    if (normalizedZone && state.activeZone !== normalizedZone) return;
    if (!force && state.selectedZone && state.activeZone === state.selectedZone) return;

    var previousZone = state.activeZone;
    applyLinkedZoneState(modal, previousZone, false);
    state.activeZone = '';

    if (force) {
      state.selectedZone = '';
      return;
    }

    if (state.selectedZone && state.selectedZone !== previousZone) {
      setLinkedActiveZone(modal, state.selectedZone);
    }
  }

  function syncLegendChipColors(modal) {
    var state = getState(modal);
    var colorMode = getColorMode(modal);
    var viewMode = getViewMode(modal);

    Object.keys(state.legendChipsByZone || {}).forEach(function(zoneLabel) {
      var chip = state.legendChipsByZone[zoneLabel];
      var zoneIndex = zoneToIndex(zoneLabel);
      if (!chip || zoneIndex < 1) return;
      chip.style.setProperty('--zone-chip-color', getZoneColor(zoneIndex, colorMode, viewMode));
    });
  }

  function applyMapBaseColors(modal) {
    var state = getState(modal);
    var colorMode = getColorMode(modal);
    var viewMode = getViewMode(modal);

    state.zonePaths.forEach(function(path) {
      var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
      var zoneIndex = zoneToIndex(zoneLabel);
      if (zoneIndex < 1) return;
      path.style.setProperty('--zone-color', getZoneColor(zoneIndex, colorMode, viewMode));
    });
  }

  function updateColorModeToggle(modal) {
    var toggle = modal && modal.querySelector('[data-zone-map-color-toggle]');
    if (!toggle) return;

    var isColorblind = getColorMode(modal) === 'colorblind';
    toggle.setAttribute('aria-pressed', isColorblind ? 'true' : 'false');
    toggle.textContent = isColorblind
      ? 'Colorblind-friendly colors: On'
      : 'Colorblind-friendly colors: Off';
  }

  function ensureMeta(modal) {
    if (!modal) return null;
    var meta = modal.querySelector('.product-zone-map-modal__meta');
    if (meta) return meta;

    var sheet = modal.querySelector('.product-zone-map-modal__sheet');
    if (!sheet) return null;

    meta = document.createElement('div');
    meta.className = 'product-zone-map-modal__meta';

    var legend = modal.querySelector('.product-zone-map-modal__legend');
    var actions = modal.querySelector('.product-zone-map-modal__actions');
    if (legend && legend.parentNode === sheet && legend.nextSibling) {
      sheet.insertBefore(meta, legend.nextSibling);
    } else if (actions && actions.parentNode === sheet && actions.nextSibling) {
      sheet.insertBefore(meta, actions.nextSibling);
    } else {
      sheet.appendChild(meta);
    }

    return meta;
  }

  function ensurePreferences(modal) {
    var preferences = modal && modal.querySelector('.product-zone-map-modal__preferences');
    if (preferences) return preferences;

    var meta = ensureMeta(modal);
    if (!meta) return null;

    preferences = document.createElement('div');
    preferences.className = 'product-zone-map-modal__preferences';
    meta.insertBefore(preferences, meta.firstChild);
    return preferences;
  }

  function createModeButton(mode) {
    var config = getViewModeConfig(mode);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-zone-map-modal__mode-button';
    button.setAttribute('data-zone-map-mode', config.id);
    button.setAttribute('aria-label', config.title);

    button.appendChild(createInlineIcon(config.icon));

    var label = document.createElement('span');
    label.className = 'product-zone-map-modal__mode-label';
    label.textContent = config.label;
    button.appendChild(label);

    return button;
  }

  function ensureModeControl(modal) {
    var state = getState(modal);
    var preferences = ensurePreferences(modal);
    if (!preferences) return null;

    var control = preferences.querySelector('[data-zone-map-mode-control]');
    if (!HEAT_INDEX_ENABLED) {
      if (control) {
        control.innerHTML = '';
        control.hidden = true;
        control.setAttribute('aria-hidden', 'true');
      }

      var legacyToggleDisabled = preferences.querySelector('[data-zone-map-view-toggle]');
      if (legacyToggleDisabled) {
        legacyToggleDisabled.hidden = true;
        legacyToggleDisabled.setAttribute('aria-hidden', 'true');
      }

      state.modeControl = null;
      return null;
    }

    if (!control) {
      control = document.createElement('div');
      control.className = 'product-zone-map-modal__mode-control';
      control.setAttribute('data-zone-map-mode-control', '');
      control.setAttribute('role', 'group');
      control.setAttribute('aria-label', 'Map view mode');

      VIEW_MODES.forEach(function(mode) {
        control.appendChild(createModeButton(mode.id));
      });

      var colorToggle = preferences.querySelector('[data-zone-map-color-toggle]');
      preferences.insertBefore(control, colorToggle || preferences.firstChild);
    } else if (!control.querySelector('[data-zone-map-mode]')) {
      VIEW_MODES.forEach(function(mode) {
        control.appendChild(createModeButton(mode.id));
      });
    }

    var legacyToggle = preferences.querySelector('[data-zone-map-view-toggle]');
    if (legacyToggle) {
      legacyToggle.hidden = true;
      legacyToggle.setAttribute('aria-hidden', 'true');
    }

    state.modeControl = control;
    updateModeControl(modal);
    return control;
  }

  function updateModeControl(modal) {
    var state = getState(modal);
    var control = state.modeControl || (modal && modal.querySelector('[data-zone-map-mode-control]'));
    if (!control) return;

    var mode = getViewMode(modal);
    Array.prototype.slice.call(control.querySelectorAll('[data-zone-map-mode]')).forEach(function(button) {
      var isActive = button.getAttribute('data-zone-map-mode') === mode;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.classList.toggle('is-active', isActive);
    });
  }

  function updateViewModeToggle(modal) {
    var toggle = modal && modal.querySelector('[data-zone-map-view-toggle]');
    if (toggle) {
      var config = getViewModeConfig(getViewMode(modal));
      toggle.setAttribute('aria-pressed', getViewMode(modal) !== 'hardiness' ? 'true' : 'false');
      toggle.textContent = 'View: ' + config.label;
    }
    updateModeControl(modal);
  }

  function applyColorMode(modal) {
    if (!modal) return;
    modal.setAttribute('data-zone-map-color-mode', getColorMode(modal));
    modal.setAttribute('data-zone-map-view', getViewMode(modal));
    modal.setAttribute('data-zone-map-mode', getViewMode(modal));
    ensureModeControl(modal);
    updateColorModeToggle(modal);
    updateViewModeToggle(modal);
    syncLegendChipColors(modal);
    if (HEAT_INDEX_ENABLED) {
      syncHeatLegendColors(modal);
    }
    applyMapBaseColors(modal);
    syncHeatOverlay(modal);
  }

  function setColorModeForAll(mode, options) {
    var normalizedMode = normalizeColorMode(mode);
    var shouldPersist = !options || options.persist !== false;

    if (shouldPersist) {
      storeColorMode(normalizedMode);
    }

    getMapSurfaces().forEach(function(modal) {
      var state = getState(modal);
      state.colorMode = normalizedMode;
      applyColorMode(modal);
    });
  }

  function setViewModeForAll(mode, options) {
    var normalizedMode = normalizeViewMode(mode);
    var shouldPersist = !options || options.persist !== false;

    if (shouldPersist) {
      storeViewMode(normalizedMode);
    }

    getMapSurfaces().forEach(function(modal) {
      var state = getState(modal);
      state.viewMode = normalizedMode;
      applyColorMode(modal);
    });
  }

  function syncHeatLegendColors(modal) {
    var colorMode = getColorMode(modal);
    Array.prototype.slice.call(modal.querySelectorAll('[data-zone-map-heat-scale-bar]')).forEach(function(bar) {
      bar.style.backgroundImage = buildHeatScaleGradient(colorMode);
    });
  }

  function buildHeatScaleGradient(colorMode) {
    var stops = [];
    for (var zone = 1; zone <= 12; zone += 1) {
      var position = ((zone - 1) / 11) * 100;
      stops.push(getHeatZoneColor(zone, colorMode) + ' ' + position.toFixed(1) + '%');
    }
    return 'linear-gradient(90deg, ' + stops.join(', ') + ')';
  }

  function renderHeatScale(modal, container) {
    var scale = document.createElement('div');
    scale.className = 'product-zone-map-modal__heat-scale';
    scale.setAttribute('data-zone-map-heat-scale', '');
    scale.setAttribute('aria-hidden', 'true');

    var low = document.createElement('span');
    low.className = 'product-zone-map-modal__heat-scale-label';
    low.textContent = 'Fewer';

    var bar = document.createElement('span');
    bar.className = 'product-zone-map-modal__heat-scale-bar';
    bar.setAttribute('data-zone-map-heat-scale-bar', '');
    bar.style.backgroundImage = buildHeatScaleGradient(getColorMode(modal));

    var high = document.createElement('span');
    high.className = 'product-zone-map-modal__heat-scale-label';
    high.textContent = 'More hot days';

    scale.appendChild(low);
    scale.appendChild(bar);
    scale.appendChild(high);
    container.appendChild(scale);
  }

  function createLegendField(labelText, selectAttr, ariaLabel, extraClass) {
    var field = document.createElement('label');
    field.className = 'product-zone-map-modal__legend-field' + (extraClass ? ' ' + extraClass : '');

    var caption = document.createElement('span');
    caption.className = 'product-zone-map-modal__legend-field-label';
    caption.textContent = labelText;

    var select = document.createElement('select');
    select.className = 'product-zone-map-modal__legend-select';
    select.setAttribute(selectAttr, '');
    select.setAttribute('aria-label', ariaLabel);

    field.appendChild(caption);
    field.appendChild(select);
    return { field: field, select: select };
  }

  function renderLegend(modal, productRange, userRange) {
    var state = getState(modal);
    var legend = modal && modal.querySelector('[data-zone-map-legend]');
    if (!legend) return;
    legend.innerHTML = '';
    state.legendChipsByZone = {};
    state.zoneSelect = null;
    state.heatSelect = null;

    var items = [
      { label: 'All zones', className: 'product-zone-map-modal__legend-dot--base' },
      { label: productRange ? ('Plant range: Zones ' + formatRange(productRange)) : 'Plant range unavailable', className: 'product-zone-map-modal__legend-dot--range' }
    ];

    if (userRange) {
      items.push({ label: 'Saved zone: ' + formatRange(userRange), className: 'product-zone-map-modal__legend-dot--user' });
    }

    if (state.searchLocation && state.searchLocation.zone) {
      items.push({
        label: 'Searched: Zone ' + formatSingleZone(state.searchLocation.zone).toUpperCase(),
        className: 'product-zone-map-modal__legend-dot--search'
      });
    }

    items.forEach(function(item) {
      var legendItem = document.createElement('span');
      legendItem.className = 'product-zone-map-modal__legend-item';

      var dot = document.createElement('span');
      dot.className = 'product-zone-map-modal__legend-dot ' + item.className;
      dot.setAttribute('aria-hidden', 'true');

      var label = document.createElement('span');
      label.textContent = item.label;

      legendItem.appendChild(dot);
      legendItem.appendChild(label);
      legend.appendChild(legendItem);
    });

    if (HEAT_INDEX_ENABLED) {
      renderHeatScale(modal, legend);
    }

    if (state.activeZone) {
      applyLinkedZoneState(modal, state.activeZone, true);
    }
  }

  function renderFallbackImage(container) {
    if (!container || container.querySelector('img')) return;
    var config = window.MrMapleZoneMapConfig || {};
    if (!config.mapImageUrl) return;
    var image = document.createElement('img');
    image.src = config.mapImageUrl;
    image.alt = 'USDA hardiness zone map';
    image.loading = 'lazy';
    container.innerHTML = '';
    container.appendChild(image);
  }

  function getRuntimeCache() {
    if (!window.MrMapleZoneMapRuntimeCache) {
      window.MrMapleZoneMapRuntimeCache = {
        svgMarkup: null,
        svgTemplate: null,
        svgFetchPromise: null,
        countyLayerMarkup: null,
        countyLayerFetchPromise: null,
        warmupScheduled: false,
        zipLocationCache: {},
        addressLocationCache: {}
      };
    }
    return window.MrMapleZoneMapRuntimeCache;
  }

  async function fetchSvgMarkup(config) {
    var cache = getRuntimeCache();
    if (cache.svgMarkup) return cache.svgMarkup;
    if (cache.svgFetchPromise) return cache.svgFetchPromise;
    if (!config || !config.svgAssetUrl) {
      throw new Error('Missing USDA zone SVG asset URL');
    }

    cache.svgFetchPromise = fetch(config.svgAssetUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to load SVG asset');
        }
        return response.text();
      })
      .then(function(svgText) {
        cache.svgMarkup = svgText.replace(/<\?xml[\s\S]*?\?>\s*/i, '').trim();
        return cache.svgMarkup;
      })
      .finally(function() {
        cache.svgFetchPromise = null;
      });

    return cache.svgFetchPromise;
  }

  function cloneCachedSvgTemplate(markup) {
    var cache = getRuntimeCache();
    if (!cache.svgTemplate) {
      var template = document.createElement('template');
      template.innerHTML = String(markup || '').trim();
      cache.svgTemplate = template.content.querySelector('[data-zone-map-svg]');
    }

    return cache.svgTemplate ? cache.svgTemplate.cloneNode(true) : null;
  }

  function deriveSiblingAssetUrl(sourceUrl, assetName) {
    var source = String(sourceUrl || '');
    if (!source || !assetName) return '';
    var cleanSource = source.split('#')[0];
    var hash = source.indexOf('#') >= 0 ? source.slice(source.indexOf('#')) : '';
    var query = '';
    var queryIndex = cleanSource.indexOf('?');
    if (queryIndex >= 0) {
      query = cleanSource.slice(queryIndex);
      cleanSource = cleanSource.slice(0, queryIndex);
    }
    if (!cleanSource) return '';
    var slashIndex = cleanSource.lastIndexOf('/');
    var prefix = slashIndex >= 0 ? cleanSource.slice(0, slashIndex + 1) : '';
    return prefix + assetName + query + hash;
  }

  function getCountyLayerSvgUrl(config) {
    if (config && config.countySvgAssetUrl) return config.countySvgAssetUrl;
    if (config && config.svgAssetUrl) {
      return deriveSiblingAssetUrl(config.svgAssetUrl, COUNTY_LAYER_ASSET_NAME);
    }
    return '';
  }

  async function fetchCountyLayerMarkup(config) {
    var cache = getRuntimeCache();
    if (cache.countyLayerMarkup) return cache.countyLayerMarkup;
    if (cache.countyLayerFetchPromise) return cache.countyLayerFetchPromise;

    var url = getCountyLayerSvgUrl(config);
    if (!url) {
      throw new Error('Missing USDA county boundary SVG asset URL');
    }

    cache.countyLayerFetchPromise = fetch(url, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to load county boundary SVG asset');
        }
        return response.text();
      })
      .then(function(svgText) {
        cache.countyLayerMarkup = svgText.replace(/<\?xml[\s\S]*?\?>\s*/i, '').trim();
        return cache.countyLayerMarkup;
      })
      .finally(function() {
        cache.countyLayerFetchPromise = null;
      });

    return cache.countyLayerFetchPromise;
  }

  function parseCountyLayer(markup) {
    if (!markup || typeof DOMParser !== 'function') return null;
    var documentFragment = new DOMParser().parseFromString(markup, 'image/svg+xml');
    var parserError = documentFragment.querySelector('parsererror');
    if (parserError) return null;
    return documentFragment.querySelector('[data-zone-map-county-layer]');
  }

  function insertCountyLayer(modal, layer) {
    var state = getState(modal);
    if (!state.svg || !layer) return null;
    if (state.countyLayer && state.countyLayer.parentNode) return state.countyLayer;

    var existing = state.svg.querySelector('[data-zone-map-county-layer]');
    if (existing) {
      state.countyLayer = existing;
      return existing;
    }

    var importedLayer = document.importNode(layer, true);
    importedLayer.setAttribute('data-zone-map-county-layer', '');
    importedLayer.setAttribute('aria-hidden', 'true');

    var stateLayer = state.svg.querySelector('.usda-zone-map__states');
    if (stateLayer && stateLayer.parentNode === state.svg) {
      state.svg.insertBefore(importedLayer, stateLayer);
    } else if (state.markerLayer && state.markerLayer.parentNode === state.svg) {
      state.svg.insertBefore(importedLayer, state.markerLayer);
    } else {
      state.svg.appendChild(importedLayer);
    }

    state.countyLayer = importedLayer;
    return importedLayer;
  }

  function ensureCountyLayer(modal) {
    var state = getState(modal);
    if (!state.svg) return Promise.resolve(null);
    if (state.countyLayer && state.countyLayer.parentNode) return Promise.resolve(state.countyLayer);
    if (state.countyLayerPromise) return state.countyLayerPromise;

    modal.setAttribute('data-zone-map-county-runtime', 'loading');
    var config = window.MrMapleZoneMapConfig || {};
    state.countyLayerPromise = fetchCountyLayerMarkup(config)
      .then(function(markup) {
        var layer = parseCountyLayer(markup);
        if (!layer) throw new Error('Missing county boundary layer');
        var insertedLayer = insertCountyLayer(modal, layer);
        modal.setAttribute('data-zone-map-county-runtime', insertedLayer ? 'ready' : 'fallback');
        return insertedLayer;
      })
      .catch(function() {
        modal.setAttribute('data-zone-map-county-runtime', 'fallback');
        return null;
      })
      .finally(function() {
        state.countyLayerPromise = null;
      });

    return state.countyLayerPromise;
  }

  function syncMapDetailLevel(modal) {
    if (!modal) return;
    var state = getState(modal);
    var zoom = state.svg && state.baseViewBox ? (state.zoom || MIN_ZOOM) : MIN_ZOOM;
    var isCountyDetail = zoom >= COUNTY_DETAIL_ZOOM;
    var labelDensity = isCountyDetail
      ? 'local'
      : (zoom >= REGIONAL_LABEL_ZOOM ? 'regional' : 'national');

    modal.setAttribute('data-zone-map-detail', isCountyDetail ? 'county' : 'state');
    modal.setAttribute('data-zone-map-label-density', labelDensity);

    if (isCountyDetail && state.svg) {
      ensureCountyLayer(modal);
    }
  }

  function scheduleSvgWarmup() {
    var cache = getRuntimeCache();
    if (cache.warmupScheduled) return;
    cache.warmupScheduled = true;

    var warmup = function() {
      var config = window.MrMapleZoneMapConfig || {};
      fetchSvgMarkup(config).catch(function() {
        // Ignore warmup failures and fall back to the image path on demand.
      });
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(warmup, { timeout: 2000 });
      return;
    }

    window.setTimeout(warmup, 250);
  }

  function getState(modal) {
    if (!modal.__zoneMapState) {
      heatInstanceCounter += 1;
      modal.__zoneMapState = {
        uid: heatInstanceCounter,
        promise: null,
        svg: null,
        zonePaths: [],
        zonePathsByZone: {},
        zonePathHitBoxes: null,
        markerLayer: null,
        countyLayer: null,
        countyLayerPromise: null,
        heatOverlay: null,
        heatZonePaths: null,
        highlightPath: null,
        highlightZone: '',
        hoverDelegationBound: false,
        pendingHoverPath: null,
        baseViewBox: null,
        viewBox: null,
        zoom: MIN_ZOOM,
        zoomControls: null,
        zoomInButton: null,
        zoomOutButton: null,
        zoomResetButton: null,
        zoomStatus: null,
        mapAnimationFrame: null,
        isPanning: false,
        panPointerId: null,
        panStartClientX: 0,
        panStartClientY: 0,
        panLatestClientX: 0,
        panLatestClientY: 0,
        panStartRect: null,
        panStartViewBox: null,
        panAnimationFrame: null,
        activePointers: {},
        isPinching: false,
        pinchStartDistance: 0,
        pinchStartZoom: MIN_ZOOM,
        pinchStartAnchor: null,
        userMarker: null,
        locationFocusRing: null,
        locationButton: null,
        userLocation: null,
        searchLocation: null,
        searchLookupPromise: null,
        searchLookupQuery: '',
        searchPanel: null,
        searchToggleButton: null,
        searchInput: null,
        searchStatus: null,
        searchSubmitButton: null,
        searchResultsElement: null,
        searchResults: [],
        searchHideTimer: null,
        shippingAddressText: '',
        shippingLocation: null,
        shippingLookupRequested: false,
        shippingLookupZip: '',
        shippingLookupPromise: null,
        locationRequested: false,
        locationPromise: null,
        renderKey: '',
        legendChipsByZone: {},
        zoneSelect: null,
        heatSelect: null,
        activeZone: '',
        selectedZone: '',
        tooltipElement: null,
        tooltipStage: null,
        tooltipStageRect: null,
        tooltipStageRectAt: 0,
        tooltipPositionFrame: null,
        pendingTooltipPoint: null,
        tooltipLastX: '',
        tooltipLastY: '',
        tooltipLastBelow: '',
        tooltipMessage: '',
        productRange: null,
        userRange: null,
        colorMode: '',
        viewMode: '',
        pickerSavedRecently: '',
        modeControl: null,
        heatZoneFilter: null,
        suppressMapHoverUntil: 0
      };
    }
    return modal.__zoneMapState;
  }

  function getProjectionValue(svg, name) {
    if (!svg) return NaN;
    return parseFloat(svg.getAttribute(name) || 'NaN');
  }

  function projectLonLatToSvg(svg, longitude, latitude) {
    if (!svg || !isFinite(longitude) || !isFinite(latitude)) return null;

    var phi1 = 29.5 * (Math.PI / 180);
    var phi2 = 45.5 * (Math.PI / 180);
    var phi0 = 23 * (Math.PI / 180);
    var lambda0 = -96 * (Math.PI / 180);

    var n = 0.5 * (Math.sin(phi1) + Math.sin(phi2));
    var c = (Math.cos(phi1) * Math.cos(phi1)) + (2 * n * Math.sin(phi1));
    var rho0 = Math.sqrt(c - (2 * n * Math.sin(phi0))) / n;

    var lam = longitude * (Math.PI / 180);
    var phi = latitude * (Math.PI / 180);
    var theta = n * (lam - lambda0);
    var rho = Math.sqrt(Math.max(0, c - (2 * n * Math.sin(phi)))) / n;
    var projectedX = rho * Math.sin(theta);
    var projectedY = rho0 - (rho * Math.cos(theta));

    if (!svg.__zoneMapProjectionMeta) {
      svg.__zoneMapProjectionMeta = {
        minX: getProjectionValue(svg, 'data-proj-min-x'),
        maxY: getProjectionValue(svg, 'data-proj-max-y'),
        scale: getProjectionValue(svg, 'data-proj-scale'),
        pad: getProjectionValue(svg, 'data-proj-pad')
      };
    }

    var minX = svg.__zoneMapProjectionMeta.minX;
    var maxY = svg.__zoneMapProjectionMeta.maxY;
    var scale = svg.__zoneMapProjectionMeta.scale;
    var pad = svg.__zoneMapProjectionMeta.pad;

    if (!isFinite(minX) || !isFinite(maxY) || !isFinite(scale) || !isFinite(pad)) {
      return null;
    }

    return {
      x: ((projectedX - minX) * scale) + pad,
      y: ((maxY - projectedY) * scale) + pad
    };
  }

  function getZonePathHitBoxes(modal) {
    var state = getState(modal);
    if (state.zonePathHitBoxes) return state.zonePathHitBoxes;
    if (!state.zonePaths || !state.zonePaths.length) {
      state.zonePathHitBoxes = [];
      return state.zonePathHitBoxes;
    }

    state.zonePathHitBoxes = state.zonePaths.map(function(path) {
      var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
      var box = null;

      if (typeof path.getBBox === 'function') {
        try {
          box = path.getBBox();
        } catch (error) {
          box = null;
        }
      }

      return {
        path: path,
        zoneLabel: zoneLabel,
        box: box,
        right: box ? box.x + box.width : 0,
        bottom: box ? box.y + box.height : 0,
        centerX: box ? box.x + (box.width / 2) : 0,
        centerY: box ? box.y + (box.height / 2) : 0
      };
    });

    return state.zonePathHitBoxes;
  }

  function pointInHitBox(point, hitBox, padding) {
    if (!point || !hitBox || !hitBox.box) return false;
    var extra = padding || 0;
    return (
      point.x >= hitBox.box.x - extra &&
      point.x <= hitBox.right + extra &&
      point.y >= hitBox.box.y - extra &&
      point.y <= hitBox.bottom + extra
    );
  }

  function getLargestMatchingZonePath(modal, range) {
    if (!range) return null;

    var bestPath = null;
    var bestArea = -1;

    getZonePathHitBoxes(modal).forEach(function(hitBox) {
      var zoneIndex = zoneToIndex(hitBox.zoneLabel);
      if (!rangeContainsIndex(range, zoneIndex) || !hitBox.box) return;

      var area = hitBox.box.width * hitBox.box.height;
      if (area > bestArea) {
        bestArea = area;
        bestPath = hitBox.path;
      }
    });

    return bestPath;
  }

  function getZonePathForProjectedPoint(modal, point, allowFallback) {
    var state = getState(modal);
    if (!point || !state.svg || !state.zonePaths || !state.zonePaths.length) return null;

    var svgPoint = null;
    if (typeof state.svg.createSVGPoint === 'function') {
      svgPoint = state.svg.createSVGPoint();
      svgPoint.x = point.x;
      svgPoint.y = point.y;
    } else if (typeof DOMPoint === 'function') {
      svgPoint = new DOMPoint(point.x, point.y);
    }

    var fallbackPath = null;
    var fallbackDistance = Infinity;

    var hitBoxes = getZonePathHitBoxes(modal);

    for (var i = 0; i < hitBoxes.length; i += 1) {
      var hitBox = hitBoxes[i];
      var path = hitBox.path;
      if (!hitBox.zoneLabel) continue;

      if (svgPoint && hitBox.box && pointInHitBox(point, hitBox, 0) && typeof path.isPointInFill === 'function') {
        try {
          if (path.isPointInFill(svgPoint)) {
            return path;
          }
        } catch (error) {
          // Ignore per-path geometry errors and continue with fallback checks.
        }
      }

      if (!allowFallback) continue;

      if (hitBox.box) {
        var dx = hitBox.centerX - point.x;
        var dy = hitBox.centerY - point.y;
        var distance = (dx * dx) + (dy * dy);

        if (pointInHitBox(point, hitBox, 8)) {
          distance *= 0.25;
        }

        if (distance < fallbackDistance) {
          fallbackDistance = distance;
          fallbackPath = path;
        }
      }
    }

    return allowFallback ? fallbackPath : null;
  }

  function getZoneLabelForProjectedPoint(modal, point) {
    var path = getZonePathForProjectedPoint(modal, point, true);
    return path ? String(path.getAttribute('data-zone') || '').toLowerCase() : '';
  }

  // Locates the heat-zone layer baked into the SVG (12 AHS bands derived from
  // PRISM daily Tmax normals: mean annual days above 86F). Coloring is applied
  // once here, not per frame.
  function ensureHeatOverlay(modal) {
    var state = getState(modal);
    if (!state.svg) return null;
    if (state.heatOverlay) return state.heatOverlay;

    var overlay = state.svg.querySelector('[data-zone-map-heat-zones]');
    if (!overlay) return null;

    state.heatOverlay = overlay;
    state.heatZonePaths = Array.prototype.slice.call(
      overlay.querySelectorAll('[data-heat-zone]')
    );
    syncHeatOverlayColors(modal);
    return overlay;
  }

  // Recolors the baked heat-zone polygons for the active color mode and applies
  // the optional heat-zone filter dimming. Runs only on color-mode/filter
  // changes, so it never touches the render loop.
  function syncHeatOverlayColors(modal) {
    var state = getState(modal);
    if (!state.heatOverlay) return;

    var colorMode = getColorMode(modal);
    var activeFilter = state.heatZoneFilter;
    var paths = state.heatZonePaths ||
      Array.prototype.slice.call(state.heatOverlay.querySelectorAll('[data-heat-zone]'));

    paths.forEach(function(path) {
      var zone = parseInt(path.getAttribute('data-heat-zone'), 10) || 1;
      path.style.setProperty('--heat-color', getHeatZoneColor(zone, colorMode));
      var dimmed = activeFilter != null && zone !== activeFilter;
      path.classList.toggle('is-dimmed', dimmed);
    });
  }

  function setHeatZoneFilter(modal, zoneNumber) {
    var state = getState(modal);
    var normalized = zoneNumber == null || zoneNumber === '' ? null : parseInt(zoneNumber, 10);
    state.heatZoneFilter = isFinite(normalized) ? normalized : null;
    if (modal) {
      modal.setAttribute('data-zone-map-heat-filter', state.heatZoneFilter == null ? '' : String(state.heatZoneFilter));
    }
    syncHeatOverlayColors(modal);
  }

  function syncHeatOverlay(modal) {
    if (!isHeatOverlayMode(getViewMode(modal))) return;
    ensureHeatOverlay(modal);
    syncHeatOverlayColors(modal);
  }

  function ensureUserMarker(modal) {
    var state = getState(modal);
    if (!state.svg) return null;

    if (!state.markerLayer) {
      state.markerLayer = state.svg.querySelector('[data-zone-map-marker-layer]');
    }

    if (!state.markerLayer) return null;

    if (!state.userMarker) {
      var marker = document.createElementNS(SVG_NS, 'g');
      marker.setAttribute('class', 'usda-zone-map__marker');
      marker.setAttribute('data-zone-map-user-marker', '');
      marker.setAttribute('tabindex', '0');
      marker.setAttribute('role', 'img');
      marker.setAttribute('aria-label', 'You are here');

      var use = document.createElementNS(SVG_NS, 'use');
      use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#usda-you-are-here-icon');
      use.setAttribute('href', '#usda-you-are-here-icon');
      marker.appendChild(use);

      ['mouseenter', 'focus', 'click'].forEach(function(eventName) {
        marker.addEventListener(eventName, function() {
          showTooltip(modal, marker.getAttribute('data-marker-tooltip') || 'You are here.');
        });
      });

      ['mouseleave', 'blur'].forEach(function(eventName) {
        marker.addEventListener(eventName, function() {
          showTooltip(modal, '');
        });
      });

      state.markerLayer.appendChild(marker);
      state.userMarker = marker;
    }

    return state.userMarker;
  }

  function updateUserMarker(modal, userRange) {
    var state = getState(modal);
    var marker = ensureUserMarker(modal);
    if (!marker) return;

    var point = null;
    var tooltip = '';
    var ariaLabel = 'You are here';
    var zoneLabel = '';

    if (state.searchLocation && state.svg) {
      point = projectLonLatToSvg(
        state.svg,
        state.searchLocation.longitude,
        state.searchLocation.latitude
      );
      if (point) {
        zoneLabel = state.searchLocation.zone || getZoneLabelForProjectedPoint(modal, point);
        tooltip = state.searchLocation.message || (
          state.searchLocation.label
            ? ('Search result for ' + state.searchLocation.label + '.')
            : 'Search result marker.'
        );
        ariaLabel = zoneLabel
          ? ('Search result marker, USDA Zone ' + formatSingleZone(zoneLabel).toUpperCase())
          : 'Search result marker';
      }
    }

    if (!point && state.shippingLocation && state.svg) {
      point = projectLonLatToSvg(
        state.svg,
        state.shippingLocation.longitude,
        state.shippingLocation.latitude
      );
      if (point) {
        zoneLabel = getZoneLabelForProjectedPoint(modal, point);
        tooltip = state.shippingLocation.label
          ? ('Shipping address marker for ' + state.shippingLocation.label + '.')
          : ('Shipping address marker for ZIP ' + state.shippingLocation.zip + '.');
        if (zoneLabel) {
          tooltip += ' USDA Zone ' + zoneLabel.toUpperCase() + '.';
        }
        tooltip += ' Approximate ZIP-level location.';
        ariaLabel = zoneLabel
          ? ('Shipping address marker, USDA Zone ' + zoneLabel.toUpperCase())
          : 'Shipping address marker';
      }
    }

    if (!point && state.userLocation && state.svg) {
      point = projectLonLatToSvg(
        state.svg,
        state.userLocation.longitude,
        state.userLocation.latitude
      );
      if (point) {
        tooltip = 'You are here. Current location marker.';
        ariaLabel = 'Current location marker';
      }
    }

    if (!point && userRange) {
      var anchorPath = getLargestMatchingZonePath(modal, userRange);
      if (anchorPath && typeof anchorPath.getBBox === 'function') {
        var box = anchorPath.getBBox();
        point = {
          x: box.x + (box.width / 2),
          y: box.y + (box.height / 2)
        };
        tooltip = 'You are here. Approximate marker centered on your saved zone.';
        ariaLabel = 'Saved zone marker';
      }
    }

    if (!point) {
      marker.setAttribute('display', 'none');
      return;
    }

    marker.removeAttribute('display');
    var markerScale = Math.max(0.16, 1 / Math.max(1, state.zoom || MIN_ZOOM));
    marker.setAttribute(
      'transform',
      'translate(' + point.x.toFixed(1) + ' ' + point.y.toFixed(1) + ') scale(' + markerScale.toFixed(3) + ')'
    );
    marker.setAttribute('data-marker-tooltip', tooltip);
    marker.setAttribute('aria-label', ariaLabel);
  }

  function ensureLocationFocusRing(modal) {
    var state = getState(modal);
    if (!state.svg) return null;

    if (!state.markerLayer) {
      state.markerLayer = state.svg.querySelector('[data-zone-map-marker-layer]');
    }
    if (!state.markerLayer) return null;

    if (!state.locationFocusRing) {
      var ring = document.createElementNS(SVG_NS, 'circle');
      ring.setAttribute('class', 'usda-zone-map__focus-ring');
      ring.setAttribute('data-zone-map-location-focus-ring', '');
      ring.setAttribute('r', String(LOCATION_FOCUS_RING_RADIUS));
      ring.setAttribute('display', 'none');
      state.markerLayer.insertBefore(ring, state.markerLayer.firstChild);
      state.locationFocusRing = ring;
    }

    return state.locationFocusRing;
  }

  function getProjectedLocation(modal, location) {
    var state = getState(modal);
    if (!location || !state.svg) return null;
    var latitude = parseFloat(location.latitude);
    var longitude = parseFloat(location.longitude);
    if (!isFinite(latitude) || !isFinite(longitude)) return null;
    var point = projectLonLatToSvg(state.svg, longitude, latitude);
    if (!point) return null;
    return {
      point: point,
      label: location.label || location.zip || 'your location',
      zone: getZoneLabelForProjectedPoint(modal, point),
      source: location.source || (location.zip ? 'zip' : 'location')
    };
  }

  function getBestKnownLocationFocus(modal, userRange) {
    var state = getState(modal);
    var projected = getProjectedLocation(modal, state.searchLocation)
      || getProjectedLocation(modal, state.shippingLocation)
      || getProjectedLocation(modal, state.userLocation);
    if (projected) return projected;

    if (userRange) {
      var anchorPath = getLargestMatchingZonePath(modal, userRange);
      if (anchorPath && typeof anchorPath.getBBox === 'function') {
        var box = anchorPath.getBBox();
        return {
          point: {
            x: box.x + (box.width / 2),
            y: box.y + (box.height / 2)
          },
          label: 'your saved hardiness zone',
          zone: userRange.display || '',
          source: 'saved-zone'
        };
      }
    }

    return null;
  }

  function getLocationFocusRingRadius(focus) {
    if (!focus) return LOCATION_FOCUS_RING_RADIUS;
    if (focus.source === 'saved-zone') return SAVED_ZONE_FOCUS_RING_RADIUS;
    if (focus.source === 'zip') return ZIP_FOCUS_RING_RADIUS;
    return LOCATION_FOCUS_RING_RADIUS;
  }

  function focusMapOnLocation(modal, focus) {
    if (!focus || !focus.point) return false;
    var state = getState(modal);
    var ring = ensureLocationFocusRing(modal);
    if (ring) {
      ring.removeAttribute('display');
      ring.setAttribute('cx', focus.point.x.toFixed(1));
      ring.setAttribute('cy', focus.point.y.toFixed(1));
      ring.setAttribute('r', String(getLocationFocusRingRadius(focus)));
    }
    updateUserMarker(modal, getUserRange(modal));
    focusMapOnPoint(modal, focus.point, LOCATION_FOCUS_ZOOM, { animate: true, duration: 520 });
    var formattedZone = formatSingleZone(focus.zone);
    setSearchStatus(
      modal,
      formattedZone
        ? ('Focused near ' + focus.label + ' in USDA Zone ' + formattedZone + '.')
        : ('Focused near ' + focus.label + '.'),
      'success'
    );
    if (state.locationButton) {
      state.locationButton.removeAttribute('aria-busy');
    }
    return true;
  }

  function requestShippingLocation(modal) {
    var state = getState(modal);
    var zipCode = getShippingZipCode(modal);
    if (!zipCode) {
      state.shippingLookupPromise = Promise.resolve(null);
      return state.shippingLookupPromise;
    }
    if (state.shippingLookupRequested && state.shippingLookupZip === zipCode) {
      return state.shippingLookupPromise || Promise.resolve(state.shippingLocation);
    }

    state.shippingLookupRequested = true;
    state.shippingLookupZip = zipCode;

    var shippingAddressText = getShippingAddressText(modal);
    var cache = getRuntimeCache();

    if (cache.zipLocationCache[zipCode]) {
      state.shippingLocation = {
        latitude: cache.zipLocationCache[zipCode].latitude,
        longitude: cache.zipLocationCache[zipCode].longitude,
        zip: zipCode,
        label: shippingAddressText || cache.zipLocationCache[zipCode].label,
        source: 'zip'
      };
      updateUserMarker(modal, getUserRange(modal));
      state.shippingLookupPromise = Promise.resolve(state.shippingLocation);
      return state.shippingLookupPromise;
    }

    state.shippingLookupPromise = fetch('https://api.zippopotam.us/us/' + encodeURIComponent(zipCode), { cache: 'force-cache' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to lookup ZIP location');
        }
        return response.json();
      })
      .then(function(data) {
        var place = data && data.places && data.places[0];
        if (!place) {
          state.shippingLookupRequested = false;
          state.shippingLookupZip = '';
          return null;
        }

        var latitude = parseFloat(place.latitude);
        var longitude = parseFloat(place.longitude);
        if (!isFinite(latitude) || !isFinite(longitude)) {
          state.shippingLookupRequested = false;
          state.shippingLookupZip = '';
          return null;
        }

        var placeLabel = [place['place name'], place['state abbreviation']].filter(Boolean).join(', ');
        cache.zipLocationCache[zipCode] = {
          latitude: latitude,
          longitude: longitude,
          label: placeLabel
        };
        state.shippingLocation = {
          latitude: latitude,
          longitude: longitude,
          zip: zipCode,
          label: shippingAddressText || placeLabel,
          source: 'zip'
        };
        updateUserMarker(modal, getUserRange(modal));
        return state.shippingLocation;
      })
      .catch(function() {
        state.shippingLookupRequested = false;
        state.shippingLookupZip = '';
        return null;
      });

    return state.shippingLookupPromise;
  }

  function getPreciseUserLocation(modal) {
    var state = getState(modal);
    var zipClimate = window.MrMapleZipClimate;
    if (state.userLocation) return Promise.resolve(state.userLocation);
    if (state.locationPromise) return state.locationPromise;
    if (!navigator.geolocation && !(zipClimate && typeof zipClimate.getCurrentPositionWithConsent === 'function')) {
      return Promise.reject(new Error('Geolocation unavailable'));
    }
    state.locationRequested = true;

    var positionPromise = zipClimate && typeof zipClimate.getCurrentPositionWithConsent === 'function'
      ? zipClimate.getCurrentPositionWithConsent({
          enableHighAccuracy: true,
          timeout: 4000,
          maximumAge: 300000
        })
      : new Promise(function(resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            maximumAge: 300000,
            timeout: 4000
          });
        });

    state.locationPromise = positionPromise
      .then(function(position) {
        state.userLocation = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          source: 'geolocation'
        };
        updateUserMarker(modal, getUserRange(modal));
        return state.userLocation;
      })
      .catch(function() {
        state.locationRequested = false;
        state.locationPromise = null;
        updateUserMarker(modal, getUserRange(modal));
        throw new Error('Location permission declined');
      });

    return state.locationPromise;
  }

  function requestPreciseUserLocation(modal) {
    getPreciseUserLocation(modal).catch(function() {
      // The visible location focus button reports permission failures when requested.
    });
  }

  function handleLocationFocus(modal) {
    var state = getState(modal);
    if (state.locationButton) {
      state.locationButton.setAttribute('aria-busy', 'true');
    }
    setSearchStatus(modal, 'Finding the best available location focus...', 'loading');

    ensureInlineMap(modal).then(function() {
      var userRange = getUserRange(modal);
      var known = getBestKnownLocationFocus(modal, userRange);
      if (known && focusMapOnLocation(modal, known)) return;

      var afterShipping = Promise.resolve(null);
      if (!state.shippingLookupRequested && getShippingAddressText(modal)) {
        afterShipping = requestShippingLocation(modal);
      }

      afterShipping
        .then(function() {
          var shippingFocus = getBestKnownLocationFocus(modal, userRange);
          if (shippingFocus && focusMapOnLocation(modal, shippingFocus)) return null;
          return getPreciseUserLocation(modal).then(function() {
            var preciseFocus = getBestKnownLocationFocus(modal, userRange);
            if (preciseFocus && focusMapOnLocation(modal, preciseFocus)) return null;
            throw new Error('Location unavailable');
          });
        })
        .catch(function() {
          if (state.locationButton) {
            state.locationButton.removeAttribute('aria-busy');
          }
          setSearchStatus(modal, 'Location permission was not granted. Search a ZIP, city, or address instead.', 'error');
        });
    });
  }

  function getZonePathFromEventTarget(target) {
    if (!(target instanceof Element)) return null;
    var path = target.closest('.usda-zone-map__zone[data-zone]');
    return path instanceof SVGPathElement ? path : null;
  }

  function getZoneTooltipForPath(modal, path) {
    if (!path) return '';
    var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
    return path.getAttribute('data-zone-map-zone-tooltip') || buildVisibleZoneTooltipText(zoneLabel);
  }

  function activateZonePathHover(modal, path, options) {
    if (!path) return;
    var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
    if (!zoneLabel) return;

    setLinkedActiveZone(modal, zoneLabel);
    if (!options || typeof options.clientX !== 'number' || typeof options.clientY !== 'number') {
      positionTooltipForPath(modal, path);
    }
    showTooltip(modal, getZoneTooltipForPath(modal, path), options);

    if (options && options.focusLegend) {
      revealLinkedLegendChip(modal, zoneLabel);
    }
  }

  function selectZonePath(modal, path, source) {
    if (!path) return;
    var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
    if (!zoneLabel) return;
    selectLinkedActiveZone(modal, zoneLabel, source || 'map');
    positionTooltipForPath(modal, path);
    showTooltip(modal, getZoneTooltipForPath(modal, path));
  }

  function bindZoneMapHoverDelegation(modal) {
    var state = getState(modal);
    if (!state.svg || state.hoverDelegationBound) return;
    state.hoverDelegationBound = true;

    var hoveredPath = null;
    var hoverFrame = null;

    function shouldIgnorePointerHover(event) {
      if (event && event.pointerType === 'touch') return true;
      if (state.isPanning || state.isPinching) return true;
      if (state.suppressMapHoverUntil && Date.now() < state.suppressMapHoverUntil) return true;
      try {
        return window.matchMedia && window.matchMedia('(hover: none)').matches;
      } catch (error) {
        return false;
      }
    }

    function commitHoveredPath(nextPath, hoverPoint) {
      if (hoveredPath === nextPath) return;

      if (hoveredPath) {
        clearLinkedActiveZone(modal, hoveredPath.getAttribute('data-zone') || '');
        showTooltip(modal, '');
      }

      hoveredPath = nextPath;

      if (hoveredPath) {
        activateZonePathHover(modal, hoveredPath, hoverPoint || null);
      }
    }

    function scheduleHoveredPath(nextPath, event) {
      state.pendingHoverPath = nextPath;
      state.pendingHoverPoint = event && typeof event.clientX === 'number' && typeof event.clientY === 'number'
        ? { clientX: event.clientX, clientY: event.clientY }
        : null;
      if (hoverFrame) return;
      hoverFrame = window.requestAnimationFrame(function() {
        hoverFrame = null;
        commitHoveredPath(state.pendingHoverPath || null, state.pendingHoverPoint);
        state.pendingHoverPath = null;
        state.pendingHoverPoint = null;
      });
    }

    state.svg.addEventListener('pointerover', function(event) {
      if (shouldIgnorePointerHover(event)) return;
      var path = getZonePathFromEventTarget(event.target);
      if (!path) return;
      scheduleHoveredPath(path, event);
    });

    state.svg.addEventListener('pointermove', function(event) {
      if (shouldIgnorePointerHover(event)) return;
      var path = getZonePathFromEventTarget(event.target);
      if (!path) return;
      if (path !== hoveredPath) {
        scheduleHoveredPath(path, event);
        return;
      }
      showTooltip(modal, getZoneTooltipForPath(modal, path), { clientX: event.clientX, clientY: event.clientY });
    });

    state.svg.addEventListener('pointerout', function(event) {
      if (shouldIgnorePointerHover(event)) return;
      var path = getZonePathFromEventTarget(event.target);
      if (!path) return;

      var nextPath = getZonePathFromEventTarget(event.relatedTarget);
      if (nextPath) {
        scheduleHoveredPath(nextPath, event);
        return;
      }

      if (path !== hoveredPath) return;
      scheduleHoveredPath(null);
    });

    state.svg.addEventListener('click', function(event) {
      var path = getZonePathFromEventTarget(event.target);
      if (!path) {
        var point = getSvgPointFromClient(modal, event.clientX, event.clientY);
        path = getZonePathForProjectedPoint(modal, point, false);
      }
      if (!path) return;

      event.preventDefault();
      activateZonePathHover(modal, path, { clientX: event.clientX, clientY: event.clientY, focusLegend: false });
    });
  }

  function bindZonePath(modal, path) {
    if (!path || path.getAttribute('data-zone-map-bound') === 'true') return;
    path.setAttribute('data-zone-map-bound', 'true');
    path.setAttribute('tabindex', '0');
    path.setAttribute('role', 'img');
    path.removeAttribute('data-zone-map-tooltip');
    path.setAttribute('data-zone-map-zone-tooltip', buildVisibleZoneTooltipText(path.getAttribute('data-zone') || ''));
    path.setAttribute('aria-label', 'USDA ' + (buildVisibleZoneTooltipText(path.getAttribute('data-zone') || '') || 'hardiness zone'));

    path.addEventListener('focus', function() {
      activateZonePathHover(modal, path, { focusLegend: true });
    });

    path.addEventListener('blur', function() {
      clearLinkedActiveZone(modal, path.getAttribute('data-zone') || '');
      showTooltip(modal, '');
    });

    path.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      activateZonePathHover(modal, path, { focusLegend: true });
    });
  }

  function suppressNativeSvgTitle(svg) {
    if (!svg) return;
    var title = svg.querySelector('title');
    if (!title) return;

    var titleText = (title.textContent || '').trim();
    if (titleText && !svg.getAttribute('aria-label')) {
      svg.setAttribute('aria-label', titleText);
    }

    var desc = svg.querySelector('desc[id]');
    if (desc && desc.id) {
      svg.setAttribute('aria-describedby', desc.id);
    }

    svg.removeAttribute('aria-labelledby');
    if (title.parentNode) {
      title.parentNode.removeChild(title);
    }
  }

  async function ensureInlineMap(modal) {
    var state = getState(modal);
    if (state.promise) return state.promise;

    state.promise = (async function() {
      var config = window.MrMapleZoneMapConfig || {};
      var canvasHost = modal.querySelector('[data-zone-map-canvas]');
      if (!canvasHost) return state;

      modal.setAttribute('data-zone-map-runtime', 'loading');

      try {
        var svgMarkup = await fetchSvgMarkup(config);
        var svgTemplate = cloneCachedSvgTemplate(svgMarkup);

        canvasHost.innerHTML = '';
        if (svgTemplate) {
          canvasHost.appendChild(svgTemplate);
        } else {
          canvasHost.insertAdjacentHTML('afterbegin', svgMarkup);
        }

        state.svg = svgTemplate || canvasHost.querySelector('[data-zone-map-svg]');
        if (!state.svg) {
          throw new Error('Missing inline USDA zone SVG');
        }

        state.svg.classList.add('product-zone-map-modal__svg');
        suppressNativeSvgTitle(state.svg);
        initializeMapView(modal);
        state.zonePaths = Array.prototype.slice.call(state.svg.querySelectorAll('[data-zone]'));
        state.zonePathsByZone = {};
        state.zonePathHitBoxes = null;
        state.markerLayer = state.svg.querySelector('[data-zone-map-marker-layer]');

        state.zonePaths.forEach(function(path) {
          var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
          if (zoneLabel) {
            state.zonePathsByZone[zoneLabel] = path;
          }
          bindZonePath(modal, path);
        });

        bindZoneMapHoverDelegation(modal);
        applyColorMode(modal);
        modal.setAttribute('data-zone-map-runtime', 'ready');
        return state;
      } catch (error) {
        state.promise = null;
        state.svg = null;
        state.zonePaths = [];
        state.zonePathsByZone = {};
        state.zonePathHitBoxes = null;
        state.markerLayer = null;
        state.countyLayer = null;
        state.countyLayerPromise = null;
        state.heatOverlay = null;
        state.heatZonePaths = null;
        state.highlightPath = null;
        state.highlightZone = '';
        state.hoverDelegationBound = false;
        state.pendingHoverPath = null;
        state.baseViewBox = null;
        state.viewBox = null;
        state.zoom = MIN_ZOOM;
        cancelMapViewAnimation(state);
        state.isPanning = false;
        state.panPointerId = null;
        state.panStartViewBox = null;
        state.userMarker = null;
        state.shippingLookupRequested = false;
        state.shippingLookupZip = '';
        state.shippingLookupPromise = null;
        state.renderKey = '';
        updateZoomControls(modal);
        modal.setAttribute('data-zone-map-runtime', 'fallback');
        renderFallbackImage(canvasHost);
        return state;
      }
    })();

    return state.promise;
  }

  function updateMapState(modal, productRange, userRange) {
    var state = getState(modal);
    if (!state.zonePaths || !state.zonePaths.length) return;
    var nextRenderKey = [
      productRange ? productRange.minIndex + '-' + productRange.maxIndex : 'none',
      userRange ? userRange.minIndex + '-' + userRange.maxIndex : 'none',
      state.searchLocation
        ? ('search:' + state.searchLocation.cacheKey + ':' + state.searchLocation.zone)
        : (state.shippingLocation ? ('ship:' + state.shippingLocation.zip) : (state.userLocation ? 'geo' : 'saved'))
    ].join('|');

    if (state.renderKey === nextRenderKey) {
      updateUserMarker(modal, userRange);
      return;
    }

    state.zonePaths.forEach(function(path) {
      var zoneLabel = (path.getAttribute('data-zone') || '').toLowerCase();
      var zoneIndex = zoneToIndex(zoneLabel);
      var inRange = rangeContainsIndex(productRange, zoneIndex);
      var isUserZone = rangeContainsIndex(userRange, zoneIndex);

      path.classList.toggle('is-in-range', inRange);
      path.classList.toggle('is-user-zone', isUserZone);
      path.classList.toggle('is-dimmed', Boolean(productRange) && !inRange && !isUserZone);
      var visibleTooltip = buildVisibleZoneTooltipText(zoneLabel);
      var accessibleTooltip = buildTooltipText(zoneLabel, productRange, userRange, path.getAttribute('data-zone-temperature') || '');
      path.removeAttribute('data-zone-map-tooltip');
      path.setAttribute('data-zone-map-zone-tooltip', visibleTooltip);
      path.setAttribute('aria-label', accessibleTooltip);
    });

    state.renderKey = nextRenderKey;
    updateUserMarker(modal, userRange);
  }

  function portalModal(modal) {
    if (isStandaloneMap(modal)) return;
    if (!modal || modal.getAttribute('data-zone-map-portaled') === 'true') return;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    modal.setAttribute('data-zone-map-portaled', 'true');
  }

  function isUsableZonePickerTrigger(candidate) {
    if (!(candidate instanceof Element)) return false;
    if (candidate.closest('[data-zone-map-modal]')) return false;
    if (candidate.getAttribute('aria-disabled') === 'true') return false;
    if ('disabled' in candidate && candidate.disabled) return false;
    if (!isVisibleElement(candidate)) return false;
    if (typeof candidate.getClientRects === 'function' && !candidate.getClientRects().length) return false;
    return true;
  }

  function findZonePickerTrigger() {
    var candidates = Array.prototype.slice.call(
      document.querySelectorAll('[data-zone-trigger], #zone-trigger, [data-onboarding-target="zone-trigger"]')
    );
    var seen = [];

    candidates = candidates.filter(function(candidate) {
      if (seen.indexOf(candidate) !== -1) return false;
      seen.push(candidate);
      return true;
    });

    return candidates.find(isUsableZonePickerTrigger) || candidates.find(function(candidate) {
      return candidate instanceof Element && !candidate.closest('[data-zone-map-modal]');
    });
  }

  function openZonePicker(modal) {
    closeModal(modal);
    var pickerTrigger = findZonePickerTrigger();

    if (pickerTrigger && typeof pickerTrigger.click === 'function') {
      window.setTimeout(function() {
        pickerTrigger.click();
      }, 40);
    }
  }

  function updateModal(modal) {
    var productRange = syncTriggerState(modal) || getProductRange(modal);
    var userRange = getUserRange(modal);
    var state = getState(modal);
    state.productRange = productRange;
    state.userRange = userRange;
    applyColorMode(modal);
    updateModalCopy(modal, productRange, userRange);
    renderLegend(modal, productRange, userRange);

    if (isStandaloneMap(modal) || modal.getAttribute('aria-hidden') === 'false' || state.svg) {
      ensureInlineMap(modal).then(function() {
        updateMapState(modal, productRange, userRange);
      });
    }

    return { productRange: productRange, userRange: userRange };
  }

  function openModal(modal) {
    if (!modal) return;
    var snapshot = updateModal(modal);
    if (!snapshot.productRange && !isStandaloneMap(modal)) return;

    portalModal(modal);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    setModalTriggerExpanded(modal, true);
    if (!isStandaloneMap(modal)) {
      document.body.classList.add('product-zone-map-open');
      focusInitialModalControl(modal);
    }

    ensureInlineMap(modal).then(function() {
      updateMapState(modal, snapshot.productRange, snapshot.userRange);
      requestShippingLocation(modal);
      if (modal.getAttribute('data-zone-map-request-location') === 'true') {
        window.requestAnimationFrame(function() {
          requestPreciseUserLocation(modal);
        });
      }
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    if (isStandaloneMap(modal)) return;
    var state = getState(modal);
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    setModalTriggerExpanded(modal, false);
    clearLinkedActiveZone(modal, '', { force: true });
    showTooltip(modal, '');
    cancelMapViewAnimation(state);
    state.isPanning = false;
    state.panPointerId = null;
    modal.setAttribute('data-zone-map-panning', 'false');
    document.body.classList.remove('product-zone-map-open');

    if (modal.__zoneMapLastTrigger && typeof modal.__zoneMapLastTrigger.focus === 'function') {
      modal.__zoneMapLastTrigger.focus({ preventScroll: true });
    }
  }

  function initModal(modal) {
    if (!modal || modal.dataset.zoneMapBound === 'true') return;
    modal.dataset.zoneMapBound = 'true';
    if (!isStandaloneMap(modal)) {
      portalModal(modal);
    } else {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
    }
    ensureZoomControls(modal);
    ensureLocationControl(modal);
    ensureSourcePlacement(modal);
    ensureModeControl(modal);
    ensureSearchControls(modal);
    syncSourceDisclosureState(modal);
    bindMapZoomInteractions(modal);
    updateModal(modal);

    var triggerSelector = '[data-zone-map-trigger][aria-controls="' + modal.id + '"]';
    Array.prototype.slice.call(document.querySelectorAll(triggerSelector)).forEach(function(trigger) {
      if (trigger.dataset.zoneMapBound === 'true') return;
      trigger.dataset.zoneMapBound = 'true';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', function(event) {
        if (trigger.getAttribute('data-zone-map-enabled') !== 'true' || trigger.getAttribute('aria-disabled') === 'true') {
          return;
        }
        modal.__zoneMapLastTrigger = trigger;
        event.preventDefault();
        openModal(modal);
      });
    });

    modal.addEventListener('click', function(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var zoomControl = target.closest('[data-zone-map-zoom]');
      if (zoomControl) {
        event.preventDefault();
        handleZoomControl(modal, zoomControl);
        return;
      }

      if (target.closest('[data-zone-map-search-toggle]')) {
        event.preventDefault();
        setSearchOpen(modal, modal.getAttribute('data-zone-map-search-open') !== 'true');
        return;
      }

      if (target.closest('[data-zone-map-location-focus]')) {
        event.preventDefault();
        handleLocationFocus(modal);
        return;
      }

      if (target.closest('[data-zone-map-close]')) {
        closeModal(modal);
        return;
      }

      if (target.closest('[data-zone-map-zone-picker]')) {
        event.preventDefault();
        handleSaveCurrentZone(modal);
        return;
      }

      if (target.closest('[data-zone-map-view-toggle]')) {
        event.preventDefault();
        var currentIndex = VIEW_MODES.map(function(mode) { return mode.id; }).indexOf(getViewMode(modal));
        var nextView = VIEW_MODES[(currentIndex + 1) % VIEW_MODES.length].id;
        setViewModeForAll(nextView, { persist: true });
        updateModal(modal);
        return;
      }

      var modeButton = target.closest('button[data-zone-map-mode]');
      if (modeButton) {
        event.preventDefault();
        setViewModeForAll(modeButton.getAttribute('data-zone-map-mode'), { persist: true });
        updateModal(modal);
        return;
      }

      if (target.closest('[data-zone-map-color-toggle]')) {
        var nextMode = getColorMode(modal) === 'colorblind' ? 'default' : 'colorblind';
        setColorModeForAll(nextMode, { persist: true });
        updateModal(modal);
      }
    });
  }

  function init() {
    var surfaces = getMapSurfaces();
    var modals = Array.prototype.slice.call(document.querySelectorAll('[data-zone-map-modal]'));
    if (!surfaces.length) return;

    window.MrMapleProductZoneMap = window.MrMapleProductZoneMap || {};
    window.MrMapleProductZoneMap.openModalById = function(id) {
      var modal = id ? document.getElementById(id) : document.querySelector('[data-zone-map-modal]');
      if (modal) openModal(modal);
    };
    window.MrMapleProductZoneMap.closeModalById = function(id) {
      var modal = id ? document.getElementById(id) : document.querySelector('[data-zone-map-modal][aria-hidden="false"]');
      if (modal) closeModal(modal);
    };
    window.MrMapleProductZoneMap.updateAll = function() {
      getMapSurfaces().forEach(updateModal);
    };

    surfaces.forEach(initModal);
    scheduleSvgWarmup();

    document.addEventListener('keydown', function(event) {
      var activeModal = document.querySelector('[data-zone-map-modal][aria-hidden="false"]');
      if (!activeModal) return;
      if (event.key === 'Escape') {
        if (activeModal.getAttribute('data-zone-map-search-open') === 'true') {
          setSearchOpen(activeModal, false, { focus: false });
          event.preventDefault();
          return;
        }
        closeModal(activeModal);
      } else if (event.key === 'Tab') {
        trapModalFocus(activeModal, event);
      }
    });

    window.addEventListener('garden:zone-updated', function() {
      getMapSurfaces().forEach(updateModal);
    });

    window.addEventListener('storage', function(event) {
      if (event.key === 'usdaZone' || event.key === 'mrmaple_zone') {
        getMapSurfaces().forEach(updateModal);
      }
      if (event.key === VIEW_MODE_STORAGE_KEY && event.newValue) {
        setViewModeForAll(event.newValue, { persist: false });
      }
    });
  }

  onReady(init);
})();
